<template>
	<div class="fill-height d-flex flex-column overflow-hidden">
		<!-- ── SECCIÓN 1: FILTROS (SUPERIOR) ── -->
		<div class="w-100">
			<v-card class="rounded-xl elevation-3 border overflow-hidden">
				<v-row no-gutters class="px-2 py-2" align="center">
					<v-col cols="12">
						<v-row dense align="end" class="mx-n1">
							<v-col cols="12" sm="6" md="3" lg="2">
								<!-- <label class="mini-label">Rango de fechas</label> -->
								<v-row dense>
									<v-col cols="12">
										<s-date label="Fecha Inicio" v-model="filter.cDateInitial" outlined dense
											hide-details class="premium-input-compact" />
									</v-col>
									<v-col cols="12">
										<s-date label="Fecha Fin" v-model="filter.cDateFin" outlined dense hide-details
											class="premium-input-compact" />
									</v-col>
								</v-row>
							</v-col>

							<v-col cols="12" sm="6" md="3" lg="2">
								<!-- <label class="mini-label">Periodo</label> -->
								<v-row dense>
									<v-col cols="12">
										<s-select label="Año" :items="years" outlined hide-details dense
											v-model="filter.PymYear" class="premium-input-compact"></s-select>
									</v-col>
									<v-col cols="12">
										<s-periods label="Semana" v-model="PymWeek" :year="filter.PymYear" :type="1"
											return-object @input="" class="premium-input-compact"></s-periods>
									</v-col>
								</v-row>
							</v-col>

							<v-col cols="12" sm="6" md="3" lg="3">
								<!-- <label class="mini-label">Localidad y Zona de Pago</label> -->
								<v-row dense>
									<v-col cols="12">
										<s-select-definition label="Localidad" :def="1253"
											v-model="filter.TypeZonLocationID" outlined dense clearable hide-details
											class="premium-input-compact"></s-select-definition>
									</v-col>
									<v-col cols="12">
										<s-select-generic label="Zona" itemtext="ZonName" itemvalue="ZonID" id="ZonName"
											full autocomplete outlined dense clearable no-default :config="configZon"
											v-model="filter.ZonID" hide-details class="premium-input-compact" />
									</v-col>
								</v-row>
							</v-col>

							<v-col cols="12" sm="6" md="3" lg="3">
								<!-- <label class="mini-label">Cultivo / Destino</label> -->
								<v-row dense>
									<v-col cols="12">
										<s-select-definition label="Cultivo" :def="1173" v-model="filter.TypeCultive"
											clearable hide-details class="premium-input-compact" />
									</v-col>
									<v-col cols="12">
										<s-select-definition label="Destino" :def="1175"
											v-model="filter.TypeDestination" clearable hide-details
											class="premium-input-compact" />
									</v-col>
								</v-row>
							</v-col>

							<v-col cols="12" sm="12" md="6" lg="2">
								<v-row dense align="end">
									<v-col cols="12" sm="6" md="6" lg="12">
										<s-select-definition label="Estado Facturación" :def="1211"
											v-model="filter.cStatePayment" clearable hide-details
											class="premium-input-compact" />
									</v-col>
								</v-row>
							</v-col>

							<!-- <v-col cols="12" sm="12" md="2" class="d-flex flex-column gap-2 pt-4 pt-md-0">
								<v-btn color="primary" block depressed
									class="rounded-xl font-weight-black elevation-2 py-5" @click="refreshPlates()"
									:loading="loadingCalculate">
									<v-icon left size="18">mdi-magnify</v-icon> BUSCAR
								</v-btn>
								<v-btn color="indigo lighten-5" block depressed
									class="rounded-xl font-weight-black indigo--text text--darken-3 py-5"
									@click="calculateAll()" :disabled="allItemsPagination.length === 0"
									:loading="loadingCalculate">
									<v-icon left size="18">mdi-calculator-variant</v-icon> CALCULAR TODO
								</v-btn>
							</v-col> -->
						</v-row>
					</v-col>
				</v-row>
			</v-card>
		</div>

		<!-- ── SECCIÓN DE TRABAJO (PANEL DIVIDIDO) ── -->
		<v-row no-gutters class="flex-grow-1 overflow-hidden mt-3" style="height: calc(100dvh - 235px);">
			<!-- Panel Izquierdo: Vehículos -->
			<v-col cols="12" md="4" lg="2" class="fill-height">
				<v-card class="rounded-xl elevation-3 fill-height d-flex flex-column border overflow-hidden pb-2">
					<div class="pa-1">
						<div class="d-flex align-center justify-space-between mb-1 px-1">
							<div class="d-flex align-center">
								<div class="premium-icon-box primary mr-2" style="padding: 8px;">
									<v-icon color="white" small>mdi-car-multiple</v-icon>
								</div>
								<h3 class="text-subtitle-1 font-weight-black grey--text text--darken-4 mb-0">
									Vehículos</h3>
							</div>
							<v-badge overlap color="primary" v-if="uniquePlates.length > 0"
								:content="uniquePlates.length" offset-x="18" offset-y="8" class="mini-badge"></v-badge>
						</div>
						<v-text-field v-model="searchPlate" placeholder="Filtrar placa..." dense hide-details
							prepend-inner-icon="mdi-magnify" outlined class="premium-search-refined"></v-text-field>
					</div>

					<div class="flex-grow-1 overflow-y-auto px-1 pb-1 custom-scrollbar" style="min-height: 0;">
						<div v-for="(p, i) in filteredPlates" :key="i"
							:class="['vehicle-card', { 'active': (selectedPlate && selectedPlate.Plate === p.Plate) }]"
							@click="selectPlate(p)">
							<div class="d-flex align-center w-100">
								<div class="plate-avatar mr-3">
									<v-icon
										:color="(selectedPlate && selectedPlate.Plate === p.Plate) ? 'white' : 'primary'">mdi-truck-outline</v-icon>
								</div>
								<div class="flex-grow-1">
									<div class="plate-number">{{ p.Plate }}</div>
								</div>
								<v-btn icon small color="primary" @click.stop="openPlateDetails(p)" class="ml-1">
									<v-icon small
										:color="(selectedPlate && selectedPlate.Plate === p.Plate) ? 'white' : 'primary'">mdi-eye</v-icon>
								</v-btn>
							</div>
						</div>
						<div v-if="filteredPlates.length === 0" class="text-center py-10">
							<v-icon size="48" color="grey lighten-3">mdi-car-off</v-icon>
							<p class="grey--text caption mt-2 px-4">No se encontraron vehículos</p>
						</div>
					</div>
				</v-card>
			</v-col>

			<!-- Panel Derecho: Detalle de Pagos -->
			<v-col cols="12" md="8" lg="10" class="fill-height pl-md-2 mt-4 mt-md-0">
				<v-card class="rounded-xl elevation-3 fill-height d-flex flex-column border overflow-hidden ">
					<div class="flex-grow-1 overflow-hidden pa-0">
						<v-card flat class="border rounded-xl fill-height overflow-hidden d-flex flex-column">
							<div class="flex-grow-1 overflow-auto custom-scrollbar h-full">
								<v-simple-table dense fixed-header height="100%" class="premium-table-workspace">
									<thead>
										<tr>
											<th>TIPO</th>
											<th>FECHA</th>
											<th class="text-center">CULTIVO</th>
											<th>DESTINO</th>
											<th v-if="filterGroup == ''">PLACA</th>
											<th>VEHÍCULO</th>
											<th class="text-center" style="min-width: 120px;">LOCALIDAD</th>
											<th class="text-center" style="min-width: 160px;">ZONA</th>
											<th class="text-center">KM</th>
											<th class="text-center">GUÍA</th>
											<th class="text-center">C. RANGO</th>
											<th class="text-center">JABAS</th>
											<th class="text-center">VUELT.</th>
											<th class="text-center highlight-blue">COSTO</th>
											<th class="text-center">EXTRA</th>
											<th class="text-center highlight-green">TOTAL</th>
											<th class="text-center" style="max-width: 110px;">C. ACORDADO</th>
											<th>PROG.</th>
											<th>COD. RESUMEN.</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(group, gIdx) in filteredGroups" :key="group.key"
											class="premium-row">
											<td>
												<div class="column-typetransport">
													<span class="status-badge" v-if="group.isSaved"
														@click="showPaymentDetail(group)" style="cursor: pointer;">
														<v-tooltip bottom>
															<template v-slot:activator="{ on, attrs }">
																<svg v-bind="attrs" v-on="on"
																	class="status-icon primary--text primary-border"
																	viewBox="0 0 24 24" fill="none"
																	stroke="currentColor" stroke-width="2"
																	stroke-linecap="round" stroke-linejoin="round">
																	<path
																		d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z">
																	</path>
																	<polyline points="14 2 14 8 20 8"></polyline>
																	<line x1="16" y1="13" x2="8" y2="13"></line>
																	<line x1="16" y1="17" x2="8" y2="17"></line>
																	<polyline points="10 9 9 9 8 9"></polyline>
																</svg>
															</template>
															<span>Resumen</span>
														</v-tooltip>
													</span>

													<v-chip small :color="`${group.Color} lighten-5`"
														style="font-size: 0.75rem;"
														:class="`${group.Color}--text text--darken-4`"
														class="font-weight-black border shadow-sm pa-1 px-2 rounded-lg">
														{{ group.TypeTransportName }}
													</v-chip>
												</div>
											</td>
											<td class="caption font-weight-black">{{
												$fun.formatDateView(group.ScheduleDate) }}</td>
											<td class="text-center py-2">
												<div class="font-weight-black">{{ group.Crop }}</div>
												<div class="x-small-text grey--text">{{ group.TypeCropName }}</div>
											</td>
											<td class="caption font-weight-bold text-center">
												<div class="grey--text x-small-text font-weight-medium">
													{{ group.ServiceType }}
												</div>
												{{ group.Destination }}
											</td>
											<td class="caption font-weight-bold" v-if="filterGroup == ''">
												{{ group.Plate }}
											</td>
											<td class="caption text-center">
												<div class="d-flex flex-column">
													<span class="font-weight-black indigo--text">{{
														group.TypeVehicleBrandName }}</span>
													<span class="grey--text x-small-text">{{ group.CapacityMin }}-{{
														group.CapacityMax }}</span>
												</div>
											</td>
											<td class="pa-2 text-center">
												<!-- <s-select-definition :def="1253" :value="group._selectedLocaleID"
													@input="onLocaleManualChange($event, group)" label=" " dense
													class="premium-inner-select" hide-details></s-select-definition> -->
												<v-chip x-small class="font-weight-medium border shadow-sm pa-1 rounded"
													style="font-size: 0.725rem;">
													{{ group.Locality }}
												</v-chip>
											</td>
											<td class="pa-2 text-center">
												<!-- <s-select :items="group._zonesGroup" autocomplete item-text="ZonName"
													item-value="ZonID" :value="group._selectedZonID" return-object
													@change="onZoneManualChange($event, group)" dense
													class="premium-inner-select" hide-details /> -->

												<div class="d-flex flex-column align-center justify-center">
													<v-chip x-small
														class="font-weight-medium border shadow-sm pa-1 rounded"
														style="font-size: 0.725rem;">
														<!-- {{ (group.TypeZonLocationID > 1) ? group.Zone : '' }} -->
														{{ group.Zone || group.OriginalZone }}
														<span v-if="group.SectorName && group.SectorName != ''">
															- {{ group.SectorName }}
														</span>
													</v-chip>
													<!-- <p style="font-size: 0.725rem;">{{ group.FarmAddress }}</p> -->

													<label class="elegant-toggle-wrap">
														<input type="checkbox" v-model="group.useSector"
															class="elegant-toggle-input"
															@change="recalculateGroupPrice(group)" />
														<span class="elegant-toggle-slider"></span>
														<span class="elegant-toggle-text">usar Sector</span>
													</label>
												</div>
											</td>
											<td class="text-center font-weight-bold success--text">
												<v-chip x-small class="font-weight-medium border shadow-sm pa-1 rounded"
													style="font-size: 0.725rem;">
													{{ group.DistanceCounter }}
												</v-chip>
												{{ group.ZoneDistanceKM || 0 }}
											</td>
											<td class="caption text-center">{{ group.ReferralGuide }}</td>
											<td class="text-center font-weight-black">{{ group.CostoRango || 0 }}</td>
											<td class="text-center teal--text font-weight-black">
												{{ [1, 2].includes(group.TypeTransport) ? group.totalActualCrates : 0 }}
												<span class="red--text x-small-text"
													v-if="group.totalExtraCrates > 0 && [1].includes(group.TypeZonLocationID)">
													+{{ group.totalExtraCrates }}
												</span>
											</td>
											<td class="text-center">
												<!-- {{ group.Transshipments.length || 0 }} -->
												{{ group._rounds }}
											</td>
											<td class="text-center highlight-blue-cell font-weight-black"
												:class="{ 'opacity-50': group.PymFixedCost > 0 }">
												{{ formatoMonedaPE(getCostoItem(group, false, true)) }}
											</td>
											<td class="text-center highlight-orange-cell font-weight-bold"
												:class="{ 'opacity-50': group.PymFixedCost > 0 }">
												{{ formatoMonedaPE(group.totalExtraCrates * group._priceAditional) }}
											</td>
											<td class="text-center highlight-green-cell font-weight-black">
												{{ formatoMonedaPE(getCostoItem(group, true)) }}
												<div v-if="group.PymFixedCost > 0"
													class="grey--text x-small-text font-weight-medium"
													style="text-decoration: line-through;">
													{{ formatoMonedaPE(getCostoItem(group, true, true)) }}
												</div>
											</td>
											<td class="text-center pa-1">
												<v-text-field v-model="group.PymFixedCost" type="number" dense
													hide-details outlined class="premium-inner-input text-center"
													placeholder="0.00"></v-text-field>
											</td>
											<td class="caption font-weight-black text-center">
												{{ group.HarvestScheduleNumber }}
											</td>
											<td class="caption font-weight-black text-center"
												style="font-size: 0.725rem !important;">
												{{ group.CodeResumen }}
											</td>
										</tr>
									</tbody>
								</v-simple-table>
							</div>

							<footer class="panel-footer bg-white border-top pa-1">
								<v-row no-gutters align="center" class="w-100">
									<v-col class="d-flex align-center">
										<div class="stat-pill">
											<span class="label">Grupos:</span>
											<span class="value">{{ filteredGroups.length }}</span>
										</div>
										<div class="stat-pill">
											<span class="label">Total Estimado:</span>
											<span class="value success--text">{{ totalPrice > 0 ?
												formatoMonedaPE(totalPrice) : 'S/ 0.00' }}</span>
										</div>
										<v-btn small icon v-if="filteredGroups.length > 0" rounded outlined
											color="success darken-1" style="background: rgba(255,255,255,0.08);"
											@click="refreshPlates">
											<v-icon small>mdi-refresh</v-icon>
										</v-btn>
									</v-col>
									<v-col cols="auto" class="d-flex align-center justify-end" style="gap:4px;">
										<!-- <v-btn v-if="filterGroup != ''" color="primary" depressed
											class="rounded-lg elevation-4 font-weight-black white--text"
											@click="filterGroup = ''; selectedPlate = null; searchPlate = ''">
											<v-icon left size="24">mdi-list-box-outline</v-icon> MOSTRAR TODO
										</v-btn> -->

										<!-- v-if="groupedItems.length > 0" -->
										<v-menu top offset-y transition="slide-y-reverse-transition">
											<template v-slot:activator="{ on, attrs }">
												<v-btn color="success darken-2 px-3" depressed v-bind="attrs" v-on="on"
													class="rounded-lg elevation-4 font-weight-black white--text">
													<v-icon>mdi-dots-vertical</v-icon>
													EXPORTAR
												</v-btn>
											</template>
											<v-list dense class="py-0">
												<v-list-item @click="exportarProvisionesExcel()" class="px-2">
													<v-list-item-icon class="mr-1">
														<v-icon color="success">mdi-file-excel-outline</v-icon>
													</v-list-item-icon>
													<v-list-item-title class="font-weight-bold text-subtitle-2">
														PROVISIONES EXCEL
													</v-list-item-title>
												</v-list-item>
												<v-divider></v-divider>
												<v-list-item @click="exportarExcel()" class="px-2">
													<v-list-item-icon class="mr-1">
														<v-icon color="success">mdi-file-excel-outline</v-icon>
													</v-list-item-icon>
													<v-list-item-title class="font-weight-bold text-subtitle-2">
														GENERAR PRECIOS EXCEL
													</v-list-item-title>
												</v-list-item>
											</v-list>
										</v-menu>
										<v-btn color="primary darken-1" depressed
											class="rounded-lg elevation-4 font-weight-black white--text"
											@click="confirmSave()" :disabled="groupedItems.length === 0"
											:loading="saving">
											<v-icon left size="24">mdi-content-save-check-outline</v-icon> GUARDAR PAGOS
										</v-btn>
									</v-col>
								</v-row>
							</footer>
						</v-card>
					</div>
				</v-card>
			</v-col>
		</v-row>

		<!-- Grid oculto -->
		<div style="display:none">
			<s-crud ref="gridTransportPayment" :filter="filter" :config="config" :rowDefault="false"
				@rowSelected="rowSelected($event)"></s-crud>
		</div>
		<AlertSunshine :dialog="loadingCalculate" :text="textLoading" />

		<!-- ── MODAL PARA CARGA DE XML (FACTURA) ── -->
		<v-dialog v-model="dialogXML" max-width="600" persistent overlay-color="grey darken-4" overlay-opacity="0.9">
			<v-card class="rounded-xl overflow-hidden elevation-24 bg-glass">
				<div class="header-premium py-5 px-3 d-flex align-center flex-wrap">
					<div class="d-flex align-center">
						<div class="icon-box mr-4 elevation-3">
							<v-icon size="40" color="white">mdi-file-xml-box</v-icon>
						</div>
						<div>
							<h2 class="white--text text-h6 font-weight-black text-uppercase letter-spacing-1">
								VALIDACIÓN DE COMPROBANTE
							</h2>
						</div>
					</div>
				</div>

				<v-card-text class="pa-3">
					<!-- Sumatoria de Jabas Fruit (Nuevo) -->
					<v-row dense v-if="totalFruitCrates > 0 || totalMaterialsCrates > 0">
						<v-col cols="4" v-if="totalFruitCrates > 0">
							<div class="modern-stat-card fruit-crates-total mb-2">
								<div class="card-icon"><v-icon color="orange darken-4">mdi-fruit-grapes</v-icon></div>
								<div class="card-content">
									<span class="label text-body-3">Total Jabas Fruta</span>
									<span class="text-h6 orange--text text--darken-4 font-weight-black">{{
										totalFruitCrates }}</span>
								</div>
							</div>
						</v-col>
						<v-col cols="4" v-if="totalMaterialsCrates > 0">
							<div class="modern-stat-card materials-crates-total mb-2">
								<div class="card-icon"><v-icon color="blue darken-4">mdi-package-variant-closed</v-icon>
								</div>
								<div class="card-content">
									<span class="label text-body-3">Total Jabas Mat.</span>
									<span class="text-h6 blue--text text--darken-4 font-weight-black">{{
										totalMaterialsCrates }}</span>
								</div>
							</div>
						</v-col>
					</v-row>

					<!-- Zona de Carga Refinada con Grid -->
					<v-row dense>
						<!-- Columna XML -->
						<v-col cols="12" :sm="xmlData.documentTypeCode == '01' ? 6 : 12">
							<div class="upload-zone-wrapper mb-2">
								<input type="file" ref="fileInputXML" id="xml-upload-input" accept=".xml" hidden
									@change="handleFileEvent">
								<label for="xml-upload-input" class="upload-zone-label xml-zone"
									:class="{ 'has-file': xmlFile }">
									<v-icon size="56" :color="xmlFile ? 'green darken-3' : 'green darken-2'"
										class="mb-2">
										{{ xmlFile ? 'mdi-file-check' : 'mdi-file-xml-box' }}
									</v-icon>
									<div class="upload-text" v-if="!xmlFile">
										<span
											class="d-block font-weight-black green--text text--darken-4 text-button">Cargar
											archivo XML</span>
										<span class="d-block green--text text--darken-1 caption">Haz clic para
											buscar</span>
									</div>
									<div class="upload-text" v-else>
										<span
											class="d-block font-weight-black green--text text--darken-3 text-body-2 truncate-text">{{
												xmlFile.name }}</span>
										<v-btn x-small color="red darken-4"
											class="font-weight-bold mt-1 white--text rounded-lg"
											@click.stop.prevent="clearXMLFile">
											<span>CAMBIAR</span>
										</v-btn>
									</div>
								</label>
							</div>
						</v-col>

						<!-- Columna PDF -->
						<v-col cols="12" sm="6" v-if="xmlData.documentTypeCode == '01'">
							<v-expand-transition>
								<div class="upload-zone-wrapper mb-2">
									<input type="file" ref="fileInputPDF" id="pdf-upload-input" accept=".pdf" hidden
										@change="handlePDFFileEvent">
									<label for="pdf-upload-input" class="upload-zone-label pdf-zone"
										:class="{ 'has-file': pdfFile }">
										<v-icon size="56" :color="pdfFile ? 'red darken-3' : 'red darken-4'"
											class="mb-2">
											{{ pdfFile ? 'mdi-file-pdf-box' : 'mdi-file-pdf' }}
										</v-icon>
										<div class="upload-text" v-if="!pdfFile">
											<span
												class="d-block font-weight-black red--text text--darken-4 text-button">Cargar
												archivo PDF</span>
											<span class="d-block red--text text--darken-1 caption">Haz clic para
												buscar</span>
										</div>
										<div class="upload-text" v-else>
											<span
												class="d-block font-weight-black red--text text--darken-3 text-body-2 truncate-text">{{
													pdfFile.name }}</span>
											<v-btn x-small color="grey darken-3"
												class="font-weight-bold mt-1 white--text rounded-lg"
												@click.stop.prevent="clearPDFFile">
												<span>CAMBIAR</span>
											</v-btn>
										</div>
									</label>
								</div>
							</v-expand-transition>
						</v-col>
					</v-row>

					<v-expand-transition>
						<div v-if="xmlData.total > 0" class="xml-details-container">
							<v-row dense>
								<v-col cols="12">
									<div class="d-flex align-center justify-space-between">
										<h4 class="text-subtitle-1 font-weight-black primary--text d-flex align-center">
											<v-icon left color="primary">mdi-information-outline</v-icon>
											Datos Extraídos
										</h4>
										<v-chip color="primary lighten-5 rounded-lg"
											class="primary--text font-weight-black" small>
											{{ xmlData.invoiceNumber }}
										</v-chip>
									</div>
								</v-col>

								<v-col cols="12" sm="6">
									<div class="modern-stat-card xml-total">
										<div class="card-icon"><v-icon color="success">mdi-xml</v-icon></div>
										<div class="card-content">
											<span class="label text-body-3">Total en XML</span>
											<span class="value success--text">{{ formatoMonedaPE(xmlData.total)
											}}</span>
										</div>
									</div>
								</v-col>

								<v-col cols="12" sm="6">
									<div class="modern-stat-card system-total">
										<div class="card-icon"><v-icon color="indigo">mdi-calculator</v-icon></div>
										<div class="card-content">
											<span class="label text-body-3">Total Generado</span>
											<span class="value indigo--text">{{ formatoMonedaPE(totalPrice) }}</span>
										</div>
									</div>
								</v-col>

								<v-col cols="12">
									<div
										:class="['validation-banner', Math.abs(xmlData.total - totalPrice) < 0.05 ? 'success-banner' : 'error-banner']">
										<div class="d-flex align-center">
											<v-avatar
												:color="Math.abs(xmlData.total - totalPrice) < 0.05 ? 'success' : 'error'"
												size="40" class="mr-4">
												<v-icon color="white">{{ Math.abs(xmlData.total - totalPrice) < 0.05
													? 'mdi-check-bold' : 'mdi-alert-octagon' }}</v-icon>
											</v-avatar>
											<div>
												<div class="banner-title font-weight-black">
													{{ Math.abs(xmlData.total - totalPrice) < 0.05
														? '¡Validación Correcta!' : 'Se detectó una discrepancia' }}
														</div>
														<div class="banner-desc caption font-weight-medium">
															{{ Math.abs(xmlData.total - totalPrice) < 0.05
																? 'Los montos coinciden perfectamente con el cálculo del sistema.'
																: 'Existe una diferencia de ' +
																formatoMonedaPE(Math.abs(xmlData.total - totalPrice)) }}
																</div>
														</div>
												</div>
											</div>
								</v-col>
							</v-row>
						</div>
					</v-expand-transition>
				</v-card-text>

				<v-card-actions class="pa-3 bg-footer-modern rounded-b-xl">
					<v-btn color="red darken-2" class="rounded-lg white--text font-weight-black px-4"
						@click="dialogXML = false" :disabled="isValidatingXML">
						CANCELAR
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="primary" class="rounded-lg font-weight-black px-4 elevation-8"
						:disabled="!xmlData.total || Math.abs(xmlData.total - totalPrice) >= 0.05 || !pdfFile"
						@click="processFinalSave" :loading="isValidatingXML">
						<v-icon left>mdi-content-save-check</v-icon>
						CONFIRMAR REGISTRO
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- ── MODAL DETALLE DE PLACA ── -->
		<v-dialog v-model="dialogPlateDetails" max-width="1200" transition="dialog-bottom-transition"
			overlay-color="grey darken-4" overlay-opacity="0.9">
			<v-card class="rounded-xl overflow-hidden elevation-24 ">
				<div class="header-premium py-3 px-3 d-flex align-center">
					<div class="icon-box mr-4 elevation-3">
						<v-icon size="32" color="white">mdi-truck-details</v-icon>
					</div>
					<div>
						<h2 class="white--text text-h6 font-weight-black text-uppercase letter-spacing-1">
							HISTORIAL DE MOVIMIENTOS: <span class="yellow--text text--lighten-2">
								{{ targetPlate }}
							</span>
						</h2>
						<p class="white--text caption mb-0 opacity-80">Registros vinculados como placa de fruta o
							materiales</p>
					</div>
					<v-spacer></v-spacer>
					<v-btn icon color="white" @click="dialogPlateDetails = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</div>

				<v-card-text class="pa-0">
					<div style="max-height: 70vh; overflow-y: auto;" class="custom-scrollbar">
						<v-data-table :headers="detailsTableHeaders" :items="detailsPlate" dense fixed-header
							class="premium-table-workspace border details-table" hide-default-footer disable-pagination
							:item-class="() => 'premium-row'">

							<template v-slot:item.ScheduleDate="{ item }">
								{{ $fun.formatDateView(item.ScheduleDate) }}
							</template>

							<template v-slot:item.Plate="{ item }">
								<div :class="{ 'highlight-target-plate': isTarget(item.Plate) }">{{ item.Plate }}</div>
							</template>

							<template v-slot:item.MaterialsPlate="{ item }">
								<div :class="{ 'highlight-target-plate': isTarget(item.MaterialsPlate) }">{{
									item.MaterialsPlate }}</div>
							</template>

							<template v-slot:item.StaffTransportPlate="{ item }">
								<div :class="{ 'highlight-target-plate': isTarget(item.StaffTransportPlate) }">{{
									item.StaffTransportPlate }}</div>
							</template>

							<template v-slot:no-data>
								<div class="text-center py-10 grey--text">No se encontraron registros detallados</div>
							</template>
						</v-data-table>
					</div>
				</v-card-text>

				<v-card-actions class="pa-3 bg-footer-modern border-top">
					<div class="stat-pill">
						<span class="label">Total Registros:</span>
						<span class="value">{{ detailsPlate.length }}</span>
					</div>
					<div class="stat-pill">
						<span class="label">Total Jabas:</span>
						<span class="value success--text">{{detailsPlate.reduce((acc, x) => acc + (x.ActualCrates ||
							0), 0)}}</span>
					</div>
					<v-spacer></v-spacer>
					<v-btn color="primary" class="rounded-lg font-weight-black px-6 elevation-4"
						@click="dialogPlateDetails = false">
						CERRAR
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- ── MODAL DETALLE DE PAGO REGISTRADO ── -->
		<v-dialog v-model="dialogPaymentDetail" max-width="600">
			<v-card class="rounded-xl overflow-hidden elevation-24" v-if="selectedPaymentDetail">
				<div class="header-premium py-3 px-4 d-flex align-center primary darken-2">
					<v-icon size="28" color="white" class="mr-3">mdi-file-check-outline</v-icon>
					<div>
						<h2 class="white--text text-subtitle-1 font-weight-black text-uppercase mb-0">
							DETALLE DE PAGO REGISTRADO
						</h2>
						<p class="white--text caption mb-0 opacity-80">{{ selectedPaymentDetail.PymTypeTransportName }}
							| {{
								$fun.formatDateView(selectedPaymentDetail.ScheduleDate) }}</p>
					</div>
					<v-spacer></v-spacer>
					<v-btn icon color="white" @click="dialogPaymentDetail = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</div>

				<v-card-text class="pa-4 bg-dashboard-main">
					<v-row dense>
						<v-col cols="12" sm="6">
							<div class="modern-stat-card mb-3">
								<div class="card-content">
									<span class="label">Factura / Documento</span>
									<span class="value primary--text">{{ selectedPaymentDetail.PymInvoiceNumber || 'N/A'
									}}</span>
								</div>
							</div>
						</v-col>
						<v-col cols="12" sm="6">
							<div class="modern-stat-card mb-3">
								<div class="card-content">
									<span class="label">Orden de Compra</span>
									<span class="value orange--text darken-4">{{ selectedPaymentDetail.OrdDocumentNumber
										||
										'PENDIENTE' }}</span>
								</div>
							</div>
						</v-col>

						<v-col cols="12" sm="4">
							<div class="stat-pill w-100 mb-2 justify-space-between pa-3">
								<span class="label">SUB TOTAL:</span>
								<span class="value text-subtitle-2">{{
									formatoMonedaPE(selectedPaymentDetail.totalSubTotal)
								}}</span>
							</div>
						</v-col>
						<v-col cols="12" sm="4">
							<div class="stat-pill w-100 mb-2 justify-space-between pa-3">
								<span class="label">ADICIONAL:</span>
								<span class="value text-subtitle-2">{{
									formatoMonedaPE(selectedPaymentDetail.totalAditional)
								}}</span>
							</div>
						</v-col>
						<v-col cols="12" sm="4">
							<div class="stat-pill w-100 mb-2 justify-space-between pa-3 success lighten-5">
								<span class="label success--text">TOTAL PAGADO:</span>
								<span class="value success--text text-subtitle-1">{{
									formatoMonedaPE(selectedPaymentDetail.totalPaid) }}</span>
							</div>
						</v-col>

						<v-col cols="12">
							<div class="d-flex align-center gap-4 mb-2">
								<div class="stat-pill">
									<span class="label">Localidad:</span>
									<span class="value caption font-weight-bold">{{
										selectedPaymentDetail.PymLocalityName
									}}</span>
								</div>
								<div class="stat-pill">
									<span class="label">Registros:</span>
									<span class="value caption font-weight-bold">{{
										selectedPaymentDetail.cantidadRegistros
									}}</span>
								</div>
								<div class="stat-pill">
									<span class="label">Jabas:</span>
									<span class="value caption font-weight-bold">{{
										selectedPaymentDetail.totalActualCrates
									}}</span>
								</div>
							</div>
						</v-col>
					</v-row>

					<v-divider class="my-2"></v-divider>
					<span class="label grey--text darken-2 font-weight-black mb-2 d-block">ÍTEMS VINCULADOS</span>

					<div style="max-height: 300px; overflow-y: auto;" class="custom-scrollbar">
						<v-simple-table dense class="premium-table-workspace border">
							<thead>
								<tr>
									<th>ID PAGO</th>
									<th class="text-center">GUÍA</th>
									<th class="text-center">JABAS</th>
									<th class="text-center">EXTRAS</th>
									<th class="text-right">SUBTOTAL</th>
									<th class="text-right">TOTAL</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="item in selectedPaymentDetail.items" :key="item.PymID">
									<td class="caption font-weight-bold">#{{ item.PymID }}</td>
									<td class="text-center caption">{{ item.PymReferralGuide }}</td>
									<td class="text-center caption">{{ item.ActualCrates }}</td>
									<td class="text-center caption">{{ item.PymExtraJabas }}</td>
									<td class="text-right caption">{{ formatoMonedaPE(item.PymSubTotal) }}</td>
									<td class="text-right caption font-weight-bold success--text">{{
										formatoMonedaPE(item.PymTotalPaid) }}</td>
								</tr>
							</tbody>
						</v-simple-table>
					</div>
				</v-card-text>
				<v-card-actions class="pa-3 bg-footer-modern border-top">
					<v-spacer></v-spacer>
					<v-btn color="primary" depressed class="rounded-lg font-weight-black px-6"
						@click="dialogPaymentDetail = false">
						CERRAR
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import _sTransportPaymentService from "../../../services/Technicalassistance/TransportPaymentService";
import _sReceptionTransfer from "../../../services/Technicalassistance/ReceptionTransferService";
import _sTasExtraTransportService from "@/services/Technicalassistance/TasExtraTransportService";
import SSelectTransport from "@/components/HarvestSchedule/SSelectTransport";
import SSelectVariety from "@/components/HarvestSchedule/SSelectVariety.vue";
import _sTransportPriceService from "@/services/Technicalassistance/TransportPriceService";
import _sTasGroupZonService from "../../../services/Technicalassistance/TasGroupZonService";
import _sTransportPaymentRecordService from "../../../services/Technicalassistance/TransportPaymentRecordService";
import _sCosteService from "@/services/Technicalassistance/TransportCosteService";
import SPeriods from "../../../components/Utils/SPeriods.vue";
import _sReferral from "@/services/Logistics/LgsReferralGuideService.js";
import _GenUploadFiles from "../../../services/General/GenUploadFiles";

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export default {
	components: { SSelectVariety, SSelectTransport, SPeriods },
	data: () => ({
		filter: {
			PymWeek: null,
			PymYear: null,
			cDateInitial: null,
			cDateFin: null,
			TypeZonLocationID: null,
			ZonID: null,
			TypeCultive: null,
			TypeDestination: null,
			cStatePayment: 0,
			Search: '',
		},
		searchPlate: '',
		selectedPlate: null,
		selectedPaymentRecords: [],
		PymWeek: null,
		allItemsCenterCosts: [],
		week: [],
		itemsWeek: [],
		selected: [],
		allItemsPagination: [],
		allTransportPrices: [],
		pricesByLocality: [],
		ZonesGroup: [],
		dialogCalculate: false,
		loadingCalculate: false,
		textLoading: "Calculando...",
		groupedItems: [],
		filterGroup: '',
		dialogPaymentDetail: false,
		selectedPaymentDetail: null,
		saving: false,
		dialogXML: false,
		dialogPlateDetails: false,
		targetPlate: '',
		detailsPlate: [],
		detailsTableHeaders: [
			{ text: '# PROG.', value: 'HarvestScheduleNumber' },
			{ text: 'ID DETALLE', value: 'ScheduleDetailID' },
			{ text: 'FECHA', value: 'ScheduleDate' },
			{ text: 'SEMANA', value: 'NumberWeek' },
			{ text: 'TIPO SERVICIO', value: 'ServiceType' },
			{ text: 'PLANTA PROCESADORA', value: 'ProcessingPlant' },
			{ text: 'PROCEDENCIA', value: 'Origin' },
			// { text: 'ID EMPACADORA', value: 'PackerID' },
			{ text: 'EMPACADORA', value: 'Packer' },
			{ text: 'CÓDIGO SENASA', value: 'SenasaCode' },
			{ text: 'PRODUCTOR', value: 'Producer' },
			// { text: 'CERTIFICADO', value: 'Certificate' },
			// { text: 'CERTIFICACIONES', value: 'Certifications' },
			// { text: 'ID LOCALIDAD', value: 'TypeZonLocationID' },
			{ text: 'LOCALIDAD', value: 'Locality' },
			// { text: 'ID ZONA', value: 'OriginalZoneID' },
			{ text: 'ZONA', value: 'OriginalZone' },
			{ text: 'KM ZONA', value: 'OriginalZoneKM' },
			{ text: 'SECTOR', value: 'SectorName' },
			{ text: 'KM SECTOR', value: 'SectorKM' },
			{ text: 'DISTRITO', value: 'DistrictFruit' },
			{ text: 'CÓDIGO PREDIO', value: 'FarmCode' },
			{ text: 'PREDIO', value: 'FarmName' },
			{ text: 'DIRECCIÓN PREDIO', value: 'FarmAddress' },
			{ text: 'SUB-ZONA', value: 'SubZone' },
			// { text: 'ID TIPO CULTIVO', value: 'TypeCrop' },
			{ text: 'TIPO CULTIVO', value: 'TypeCropName' },
			{ text: 'CULTIVO', value: 'Crop' },
			// { text: 'ID CULTIVO', value: 'TypeCultive' },
			{ text: 'SUPERVISOR ZONA', value: 'ZoneSupervisor' },
			{ text: 'SUPERVISOR COSECHA', value: 'HarvestSupervisor' },
			{ text: 'DESTINO', value: 'Destination' },
			{ text: 'ID DESTINO', value: 'DestinationID' },
			{ text: 'VARIEDAD', value: 'Variety' },
			{ text: 'CANT. JABAS PROG.', value: 'CrateQuantity' },
			// { text: 'ID CAPATAZ', value: 'ForemenID' },
			{ text: 'DNI CAPATAZ', value: 'ForemenDocumentNumber' },
			{ text: 'CAPATAZ', value: 'Foremen' },
			{ text: 'COSECHADORES', value: 'Harvesters' },
			// { text: 'ID PLACA', value: 'PlateID' },
			{ text: 'PLACA FRUTA', value: 'Plate', align: 'center' },
			// { text: 'ID TIPO VEHÍCULO', value: 'TypeVehicle' },
			{ text: 'TIPO VEHÍCULO', value: 'TypeVehicleName' },
			// { text: 'ID MARCA', value: 'TypeVehicleBrand' },
			{ text: 'MARCA VEHÍCULO', value: 'TypeVehicleBrandName' },
			{ text: 'RUC', value: 'RUC' },
			{ text: 'RAZÓN SOCIAL', value: "BusinessName" },
			{ text: 'CAPACIDAD', value: 'Capacity' },
			{ text: 'CAPACIDAD MÍN.', value: 'CapacityMin' },
			{ text: 'CAPACIDAD MÁX.', value: 'CapacityMax' },
			{ text: 'GUÍA COSECHA', value: 'HarvestGuide' },
			{ text: 'GUÍA REMISIÓN', value: 'ReferralGuide' },
			{ text: 'ESTADO', value: 'Status' },
			{ text: 'LOTE PRODUCCIÓN', value: 'ProductionLot' },
			{ text: 'SECUENCIA LOTE', value: 'LotSequence' },
			{ text: 'KG INGRESO', value: 'IntakeKg' },
			{ text: 'PESO NETO', value: 'NetWeight' },
			{ text: 'KG POR JABA', value: 'KgPerCrate' },
			{ text: 'PESO BRUTO', value: 'GrossWeight' },
			{ text: 'PESO GUÍA', value: 'GuideWeight' },
			{ text: 'PLACA MATERIALES', value: 'MaterialsPlate', align: 'center' },
			{ text: 'DISTRITO MAT.', value: 'DistrictMaterial' },
			// { text: 'ID PLACA MAT.', value: 'MaterialsPlateID' },
			// { text: 'ID MARCA MAT.', value: 'MaterialsPlateBrand' },
			{ text: 'MARCA MAT.', value: 'MaterialsPlateBrandName' },
			{ text: 'CAP. MÍN. MAT.', value: 'MaterialsPlateMin' },
			{ text: 'CAP. MÁX. MAT.', value: 'MaterialsPlateMax' },
			{ text: 'GUÍA MATERIALES', value: 'MaterialsGuide' },
			{ text: 'GUÍA TRANSPORTISTA', value: 'CarrierGuide' },
			{ text: 'SELLO SUNSHINE', value: 'SunshineSeal' },
			{ text: 'JABAS REALES', value: 'ActualCrates' },
			{ text: 'OBSERVACIONES', value: 'Observations' },
			{ text: '% DESCARTE', value: 'DiscardPercentage' },
			{ text: 'TOTAL KG DESCARTE', value: 'TotalDiscardKg' },
			{ text: 'TOTAL KG PAGADOS', value: 'TotalPaidKg' },
			{ text: 'PRECIO USD', value: 'PriceUSD' },
			{ text: 'TIPO PROVEEDOR', value: 'SupplierType' },
			{ text: 'TIPO EMBARQUE', value: 'ShipmentType' },
			{ text: 'ID PLACA PERS.', value: 'StaffTransportPlateID' },
			{ text: 'PLACA PERSONAL', value: "StaffTransportPlate" },
			{ text: 'RUC PERSONAL', value: 'StaffTransportRUC' },
			{ text: 'RAZÓN SOCIAL PERS.', value: 'StaffTransportBusinessName' },
			{ text: 'ID PAGO', value: 'PymID' },
			{ text: 'CÓDIGO FRUTA', value: 'CodeResumenFruta' },
			{ text: 'CÓDIGO MATERIAL', value: 'CodeResumenMaterial' },
		],
		pdfFile: null,
		xmlFile: null,
		xmlData: {
			invoiceNumber: '',
			total: 0,
			currency: '',
			documentTypeCode: '',
			issuerRUC: ''
		},
		isValidatingXML: false,
		config: {
			service: _sTransportPaymentService,
			model: {
				ScheduleDetailID: "ID",
				ScheduleDate: "date",
			},
			headers: [
				{ text: "Fecha", value: "ScheduleDate" },
				{ text: "Semana", value: "NumberWeek", align: "center" },
				{ text: "RUC", value: "RUC" },
				{ text: "Razón Social", value: "BusinessName", width: 150 },
				{ text: "Tipo Servicio", value: "ServiceType" },
				{ text: "Procedencia", value: "Origin", width: 100 },
				{ text: "Empacadora", value: "Packer" },
				{ text: "Certificaciones", value: "Certifications" },
				{ text: "Cultivo", value: "Crop" },
				{ text: "Tipo Cultivo", value: "TypeCropName" },
				{ text: "Variedad", value: "Variety" },
				{ text: "Localidad", value: "Locality" },
				{ text: "Zona", value: "Zone" },
				{ text: "Planta Procesadora", value: "ProcessingPlant" },
				{ text: "Destino", value: "Destination" },
				{ text: "Jabas Programadas", value: "CrateQuantity", align: "center" },
				{ text: "Jabas Reales", value: "ActualCrates", align: "center" },
				{ text: "Placa", value: "Plate" },
				{ text: "Tipo Vehiculo", value: "TypeVehicleBrand" },
				{ text: "Guía Cosecha", value: "HarvestGuide", width: 120 },
				{ text: "Guía Remisión", value: "ReferralGuide", width: 120 },
				{ text: "Estado", value: "Status" },
				{ text: "Capacidad", value: "Capacity" },
				{ text: "Kg/Jaba", value: "KgPerCrate" },
				{ text: "Observaciones", value: "Observations" },
				{ text: "Placa Materiales", value: "MaterialsPlate" },
				{ text: "Guía Transportista", value: "CarrierGuide" },
				{ text: "Guía Materiales", value: "MaterialsGuide", width: 120 },
				{ text: "ID Detalle Programación", value: "ScheduleDetailID" },
			],
		}
	}),
	computed: {
		totalCrates() {
			return this.groupedItems.reduce((acc, g) => acc + (g.totalCrateQuantity || 0), 0);
		},
		totalActualCrates() {
			const q = (this.filterGroup || '').trim().toLowerCase();
			if (!q) {
				return this.groupedItems.filter(g => ![3, 4].includes(g.TypeTransport)).reduce((acc, g) => acc + (g.totalActualCrates || 0), 0);
			}
			return this.filteredGroups.filter(g => ![3, 4].includes(g.TypeTransport)).reduce((acc, g) => acc + (g.totalActualCrates || 0), 0);
		},
		totalFruitCrates() {
			return this.filteredGroups.filter(g => g.TypeTransport == 1).reduce((acc, g) => acc + (g.totalActualCrates || 0), 0);
		},
		totalMaterialsCrates() {
			return this.filteredGroups.filter(g => g.TypeTransport == 2).reduce((acc, g) => acc + (g.totalActualCrates || 0), 0);
		},
		totalPrice() {
			const q = (this.filterGroup || '').trim().toLowerCase();
			if (!q) {
				return this.groupedItems.reduce((acc, g) => acc + this.getCostoItem(g, true), 0);
			}
			return this.filteredGroups.reduce((acc, g) => acc + this.getCostoItem(g, true), 0);
		},
		filteredGroups() {
			const q = (this.filterGroup || '').trim().toLowerCase();
			const items = !q ? [...this.groupedItems] : this.groupedItems.filter(g => {
				const locality = (g.Locality || '').toLowerCase();
				const zone = (g._selectedZonName || g.Zone || '').toLowerCase();
				const plate = (g.Plate || '').toLowerCase();
				return locality.includes(q) || zone.includes(q) || plate.includes(q);
			});
			return items.sort((a, b) => new Date(a.ScheduleDate) - new Date(b.ScheduleDate));
		},
		uniquePlates() {
			const platesMap = new Map();
			const state = this.filter.cStatePayment || 0;

			this.allItemsPagination.forEach(item => {
				// Evaluar Placa de Fruta
				if (item.Plate && item.Plate.trim() !== '') {
					let include = true;
					if (state > 0) {
						const pymId = item.PymID || 0;
						const ordId = item.OrdID || 0;
						if (state == 1) include = (pymId == 0 && ordId == 0);
						else if (state == 2) include = (pymId > 0 && ordId == 0);
						else if (state == 3) include = (pymId > 0 && ordId > 0);
					}
					if (include) {
						const p = item.Plate.trim();
						if (!platesMap.has(p)) platesMap.set(p, { Plate: p, Records: 0 });
						platesMap.get(p).Records++;
					}
				}

				// Evaluar Placa de Materiales
				if (item.MaterialsPlate && item.MaterialsPlate.trim() !== '') {
					let include = true;
					if (state > 0) {
						const pymIdMat = item.PymIDMat || 0;
						const ordIdMat = item.OrdIDMat || 0;
						if (state == 1) include = (pymIdMat == 0 && ordIdMat == 0);
						else if (state == 2) include = (pymIdMat > 0 && ordIdMat == 0);
						else if (state == 3) include = (pymIdMat > 0 && ordIdMat > 0);
					}
					if (include) {
						const p = item.MaterialsPlate.trim();
						if (!platesMap.has(p)) platesMap.set(p, { Plate: p, Records: 0 });
						platesMap.get(p).Records++;
					}
				}
			});
			return Array.from(platesMap.values()).sort((a, b) => a.Plate.localeCompare(b.Plate));
		},
		filteredPlates() {
			const q = (this.searchPlate || '').toLowerCase().trim();
			if (!q) return this.uniquePlates;
			return this.uniquePlates.filter(p => (p.Plate || '').toLowerCase().includes(q) || (p.MaterialsPlate || '').toLowerCase().includes(q));
		}
	},
	created() {
		this.loadPricesTransport().then(prices => {
			this.allTransportPrices = prices || [];
		});
		this.configZon = {
			url: _sTransportPriceService.GetZon(),
			title: this.label,
			params: { search: "", requestID: this.$fun.getUserID() },
		};
		for (let i = 1; i <= 53; i++) {
			this.itemsWeek.push({ text: i, value: i });
		}
		this.years = this.$fun.getTop5LastYears();
		this.filter.PymYear = this.$moment().year();
		this.restartFilter();
	},
	watch: {
		PymWeek(value) {
			this.filter.cDateInitial = value ? value.PdsDateBegin : null;
			this.filter.cDateFin = value ? value.PdsDateEnd : null;
			this.filter.PymWeek = value ? value.PdsNum : null;
		},
		"filter.PymYear"() {
			this.week = [];
			this.PymWeek = null;
			this.filter.PymWeek = null;
			this.restartFilter();
		},
		"filter": {
			handler() {
				this.refreshPlates();
			},
			deep: true,
		}
	},
	methods: {
		rowSelected(items) {
			const onlyPayable = items.filter(x => !x.PymID || x.PymID === 0);
			this.selected = [...onlyPayable];
			if (items.length !== onlyPayable.length && this.$refs.gridTransportPayment) {
				this.$refs.gridTransportPayment.selected = [...onlyPayable];
			}
		},
		parseFecha(dmy) {
			const [d, m, y] = dmy.split('/');
			return new Date(y, m - 1, d);
		},
		async calculatePayment() {
			if (this.selected.length == 0) {
				this.$fun.alert("No existen registros seleccionados", "warning");
				return;
			}
			this.textLoading = "Calculando..."
			this.loadingCalculate = true;
			try {

				// const dataPagination = await this.getPaginationAsList(1);
				if (this.allItemsPagination.length == 0) {
					this.$fun.alert(`NO SE ENCONTRARON REGISTROS.`, "warning");
					return;
				}

				const zonesCache = {};
				const PlatesFruta = [...this.selected.map(x => x.Plate)];
				const PlatesMateriales = [...this.selected.map(x => x.MaterialsPlate)];

				// M4I766, M2X894, P3V832
				const platesVehStr = [...new Set([...PlatesFruta, ...PlatesMateriales])].filter(x => x != null && x != '').join(",");
				const [transshipments, extraTransports] = await this.getDataTransbordsAndExtras(platesVehStr);
				// const zonesCache = await this.getZonesByLocation(this.selected);
				// console.log(JSON.parse(JSON.stringify({ transshipments, extraTransports }))) // TODO: Revisar

				const grupos = this.groupDataByTransport(this.allItemsPagination);
				const groupByplate = await this.groupByPlates(grupos, extraTransports, transshipments);
				console.log(JSON.parse(JSON.stringify({ groupByplate })))
				this.groupedItems = Object.values(groupByplate).flat();
				this.enrichGroupsWithPaymentRecords();
				this.dialogCalculate = true;
				// return;
			} finally {
				this.loadingCalculate = false;
			}
		},
		async refreshPlates() {
			this.textLoading = "Calculando Precios...";
			this.loadingCalculate = true;
			try {
				this.allItemsPagination = await this.getPaginationAsList();
				this.groupedItems = [];
				this.selectedPlate = null;
			} finally {
				this.loadingCalculate = false;
			}
		},
		async calculateAll() {
			if (this.allItemsPagination.length === 0) return;
			this.selected = [...this.allItemsPagination];
			await this.calculatePayment();
			this.dialogCalculate = false;
		},
		enrichGroupsWithPaymentRecords() {
			if (!this.groupedItems.length) return;

			this.groupedItems.forEach(x => {
				const typetransport = x.TypeTransport;
				const sheduledate = this.$fun.formatDateView(x.ScheduleDate);
				const PaymentRecord = this.selectedPaymentRecords.find(r =>
					this.$fun.formatDateView(r.ScheduleDate) == sheduledate &&
					r.PymTypeTransport == typetransport
				);

				this.$set(x, "isSaved", PaymentRecord !== undefined);
				this.$set(x, "PaymentRecord", PaymentRecord);
			});
		},
		showPaymentDetail(group) {
			if (!group.PaymentRecord) return;
			this.selectedPaymentDetail = group.PaymentRecord;
			this.dialogPaymentDetail = true;
		},
		async selectPlate(item) {
			if (this.filterGroup == item.Plate && this.selectedPlate?.Plate == item.Plate) return;
			this.selectedPaymentRecords = await this.loadPaymentsRecordGroup(item.Plate);
			this.enrichGroupsWithPaymentRecords();
			this.selectedPlate = item;
			this.filterGroup = item.Plate;
			if (this.groupedItems.length === 0) {
				this.calculateAll();
			}
		},
		openPlateDetails(plate) {
			this.targetPlate = plate.Plate;
			const q = (this.targetPlate || '').trim().toUpperCase();
			this.detailsPlate = this.allItemsPagination.filter(x =>
				(x.Plate && x.Plate.trim().toUpperCase() === q) ||
				(x.MaterialsPlate && x.MaterialsPlate.trim().toUpperCase() === q)
			).map(x => {
				return {
					...x,
					CodeResumenFruta: this.getDateInt(x.ScheduleDate) + x.Plate + 'FRUTA' + x.Zone,
					CodeResumenMaterial: this.getDateInt(x.ScheduleDate) + x.MaterialsPlate + 'MATERIAL' + x.Zone
				}
			}).sort((a, b) => new Date(a.ScheduleDate) - new Date(b.ScheduleDate));
			this.dialogPlateDetails = true;
		},
		isTarget(plate) {
			if (!plate || !this.targetPlate) return false;
			return plate.trim().toUpperCase() === this.targetPlate.trim().toUpperCase();
		},
		closeDialog() {
			this.dialogCalculate = false;
			this.groupedItems = [];
		},
		async loadPriceTransport(params) {
			try {
				const response = await _sTransportPriceService.getPriceTransport(params, this.$fun.getUserID());
				return response.status == 200 ? response.data : null;
			} catch (error) {
				return null;
			}
		},
		getCostoItem(group, isTotal = false, ignoreFixed = false) {
			if (!ignoreFixed && group.PymFixedCost > 0) return Number(group.PymFixedCost);
			if (group.price == undefined || group.price == null) return 0;
			const divisor = (group.hasFruit && group.hasMaterials) ? 2 : 1;
			const type = group.price ? group.price.TypeCalculate : '';
			let total = ['zona_vehiculo_km', 'fijo_zona', 'fijo_vehiculo', 'trasbordo'].includes(type) ? group._price : (group._price * group.totalActualCrates);
			let totalExtras = 0;
			if (group.TypeTransport == 1 && isTotal) {
				totalExtras = group.totalExtraCrates * group._priceAditional;
			}

			//CUANDO ES TRASBORDO SOLO DEBE CONTAR UNA VEZ PARA EL MULTIPLICADOR
			const rounds = group.TypeTransport == 4 ? 1 : group._rounds;
			return ((total * (isTotal ? rounds : 1)) / divisor) + totalExtras;
		},
		recalculateGroupPrice(group) {
			group.DistanceCounter = this.getDistanceCounter(group);
			group.ZoneDistanceKM = this.getZoneDistanceKM(group);

			const pricesList = Array.isArray(this.allTransportPrices) ? this.allTransportPrices : [];
			const price = this.getPriceDatabase(group, pricesList);

			group.price = price;
			group._price = price ? (price.Price || 0) : 0;
			group._priceAditional = price ? (price.PriceAditional || 0) : 0;

			const totalExtraCrates = (group._selectedLocaleID && group.TypeTransport == 1 && !group.Packer && group.totalActualCrates > group.CostoRango) ? (group.totalActualCrates - group.CostoRango) : 0;
			group.totalExtraCrates = totalExtraCrates;
			group._totalExtraAmount = (totalExtraCrates || 0) * (group._priceAditional || 0);

			group._subTotalAmount = this.getCostoItem(group);
			group._totalAmount = this.getCostoItem(group, true);
		},
		async getPaginationAsList(cStatePayment = 0) {
			const params = {
				filter: { ...this.filter, Search: "", cStatePayment: cStatePayment }, draw: 1, start: 0, length: -1,
				order: [{ dir: "asc", column: "" }], searchText: "",
			};
			const response = await _sTransportPaymentService.pagination(params, this.$fun.getUserID());
			return response.status == 200 ? response.data?.data : [];
		},
		getDateInt(fechaStr) {
			if (!fechaStr) return "0";
			const fechaLimpia = fechaStr.substring(0, 10);
			const fechaJS = new Date(fechaLimpia + 'T00:00:00');

			if (isNaN(fechaJS.getTime())) {
				return "0";
			}

			// 2. Usamos el factor de ajuste estándar: El 01/01/1970 equivale al día 25569 en Excel
			const factorAjusteExcel = 25569;
			const milisegundosPorDia = 1000 * 60 * 60 * 24;

			// 3. Calculamos los días transcurridos desde 1970 usando el timestamp puro (.getTime())
			const diasDesde1970 = fechaJS.getTime() / milisegundosPorDia;

			// 4. Ajuste por el bug histórico de Excel (cuenta el año 1900 como bisiesto)
			return (Math.floor(diasDesde1970) + factorAjusteExcel).toString();
		},
		formatoMonedaPE(valor) {
			return new Intl.NumberFormat('es-PE', {
				style: 'currency',
				currency: 'PEN',
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}).format(valor);
		},
		async confirmSave() {
			const groupsWithZeroTotal = this.filteredGroups.filter(g => this.getCostoItem(g, true) <= 0);
			if (groupsWithZeroTotal.length > 0) {
				const plates = [...new Set(groupsWithZeroTotal.map(g => g.Plate))].join(', ');
				this.$fun.alert(`VEHÍCULOS CON PLACA (${plates}) NO CONTIENEN MONTOS VÁLIDOS.`, "warning");
				return;
			}

			// Inicializar datos XML y abrir modal
			this.xmlFile = null;
			this.pdfFile = null;
			this.xmlData = { invoiceNumber: '', total: 0, currency: '', documentTypeCode: '', issuerRUC: '' };
			if (this.$refs.fileInputXML) this.$refs.fileInputXML.value = "";
			if (this.$refs.fileInputPDF) this.$refs.fileInputPDF.value = "";
			this.dialogXML = true;
		},
		handleFileEvent(e) {
			const file = e.target.files[0];
			if (file) this.onXMLFileChange(file);
		},
		clearXMLFile() {
			this.xmlFile = null;
			this.pdfFile = null;
			this.xmlData = { invoiceNumber: '', total: 0, currency: '', documentTypeCode: '', issuerRUC: '' };
			if (this.$refs.fileInputXML) this.$refs.fileInputXML.value = "";
			if (this.$refs.fileInputPDF) this.$refs.fileInputPDF.value = "";
		},
		handlePDFFileEvent(e) {
			const file = e.target.files[0];
			if (file) this.pdfFile = file;
		},
		clearPDFFile() {
			this.pdfFile = null;
			if (this.$refs.fileInputPDF) this.$refs.fileInputPDF.value = "";
		},
		onXMLFileChange(file) {
			this.xmlFile = file;
			this.pdfFile = null;
			if (this.$refs.fileInputPDF) this.$refs.fileInputPDF.value = "";
			if (!file) {
				this.xmlData = { invoiceNumber: '', total: 0, currency: '', documentTypeCode: '', issuerRUC: '' };
				return;
			}

			const reader = new FileReader();
			reader.onload = (e) => {
				try {
					const parser = new DOMParser();
					const xmlDoc = parser.parseFromString(e.target.result, "text/xml");

					// Intentar extraer el número de factura - cbc:ID dentro de Invoice
					const invoiceNumber = xmlDoc.getElementsByTagName("cbc:ID")[0]?.textContent || '';

					// Captar el código del tipo de documento
					const documentTypeCode = xmlDoc.getElementsByTagName("cbc:InvoiceTypeCode")[0]?.textContent || '';

					// Captar el RUC del emisor
					const supplierParty = xmlDoc.getElementsByTagName("cac:AccountingSupplierParty")[0];
					const issuerRUC = supplierParty?.getElementsByTagName("cbc:ID")[0]?.textContent || '';

					// Intentar extraer el total (PayableAmount)
					// Comúnmente en cac:LegalMonetaryTotal / cbc:PayableAmount
					let total = 0;
					const payableAmountNode = xmlDoc.getElementsByTagName("cbc:PayableAmount")[0];
					if (payableAmountNode) {
						total = parseFloat(payableAmountNode.textContent);
					}

					this.xmlData = {
						invoiceNumber,
						documentTypeCode,
						issuerRUC,
						total: isNaN(total) ? 0 : total,
						currency: payableAmountNode?.getAttribute("currencyID") || 'PEN'
					};

					if (this.xmlData.total === 0) {
						this.$fun.alert("No se pudo extraer el total del XML. Verifique el formato.", "warning");
					}
				} catch (error) {
					console.error("Error al parsear XML:", error);
					this.$fun.alert("Error al leer el archivo XML.", "error");
				}
			};
			reader.readAsText(file);
		},
		async processFinalSave() {
			if (Math.abs(this.xmlData.total - this.totalPrice) >= 0.05) {
				this.$fun.alert("El total del XML no coincide con el total generado.", "warning");
				return;
			}

			this.$fun.alert("¿Seguro de Guardar Pago?", "question").then(async (val) => {
				if (val.value) {
					await this.executeSavePayment();
				}
			});
		},
		async executeSavePayment() {
			this.textLoading = "Guardando...";
			this.loadingCalculate = true;
			this.isValidatingXML = true;
			try {
				const paymentRecords = [];
				const currentUserID = this.$fun.getUserID();
				let invoiceNumber = null;
				let pathInvoiceNumberXml = null;
				let pathInvoiceNumberPdf = null;

				if (this.xmlData?.invoiceNumber) {
					invoiceNumber = this.xmlData.invoiceNumber; // necesito solo (E001-188)
					const fileName = `${this.xmlData?.issuerRUC}-${this.xmlData?.documentTypeCode}-${this.xmlData.invoiceNumber}`;

					const uploadedXML = await this.loadFileOnServer(this.xmlFile, fileName);
					// console.log({ uploadedXML })
					if (uploadedXML.success) {
						pathInvoiceNumberXml = uploadedXML.fileName; // Resultado retorna con extencion (E001-188.XML), 
					} else {
						this.$fun.alert("Error al subir XML, " + uploadedXML.message, "error");
					}

					if (this.pdfFile) {
						const uploadedPDF = await this.loadFileOnServer(this.pdfFile, fileName);
						if (uploadedPDF.success) {
							pathInvoiceNumberPdf = uploadedPDF.fileName; // Resultado retorna con extencion (E001-188.PDF), 
						} else {
							this.$fun.alert("Error al subir PDF, " + uploadedPDF.message, "error");
						}
					}
				}

				this.filteredGroups.filter(g => g.TypeTransport < 3).forEach(group => {
					const recordsDetailCount = group.items.length > 0 ? group.items.length : 1;
					let totalItemBase = this.getCostoItem(group).toFixed(2);
					let totalExtraBase = (group.TypeTransport == 1 && group.totalExtraCrates > 0 && !(group.PymFixedCost > 0)) ? (group.totalExtraCrates * group._priceAditional).toFixed(2) : 0;

					group.items.forEach((item) => {
						const amountDetail = ((item.ActualCrates * totalItemBase) / group.totalActualCrates).toFixed(2);
						const amountExtrasDetail = totalExtraBase > 0 ? (totalExtraBase / recordsDetailCount).toFixed(2) : 0;
						const jbsExtrasDetail = (totalExtraBase > 0) ? (group.totalExtraCrates / recordsDetailCount) : 0;

						paymentRecords.push(this.getDataForSave(group, amountDetail, amountExtrasDetail, jbsExtrasDetail, invoiceNumber, pathInvoiceNumberXml, pathInvoiceNumberPdf, currentUserID, item.ScheduleDetailID, item.HarvestScheduleNumber));
					});
				});

				this.filteredGroups.filter(g => g.TypeTransport > 2).forEach(group => {
					paymentRecords.push(this.getDataForSave(group, this.getCostoItem(group, true).toFixed(2), 0, 0, invoiceNumber, pathInvoiceNumberXml, pathInvoiceNumberPdf, currentUserID));
				});

				// this.filteredGroups.filter(g => g.TypeTransport == 4).forEach(group => {
				// 	paymentRecords.push(this.getDataForSave(null, null, group, this.getCostoItem(group).toFixed(2), 0, 0, invoiceNumber, pathInvoiceNumberXml, pathInvoiceNumberPdf, currentUserID));
				// });

				// this.filteredGroups.filter(g => g.TypeTransport == 5).forEach(group => {
				// 	paymentRecords.push(this.getDataForSave(null, null, group, this.getCostoItem(group).toFixed(2), 0, 0, invoiceNumber, pathInvoiceNumberXml, pathInvoiceNumberPdf, currentUserID));
				// });

				// const guidesRemision = [...new Set(paymentRecords.map(g => g.PymReferralGuide))];
				// const recordsWithGuide = await this.savePDFGuia(paymentRecords);
				console.log("Registros a guardar:", JSON.parse(JSON.stringify(paymentRecords)));

				const res = await _sTransportPaymentRecordService.saveMassive(paymentRecords, currentUserID);
				if (res.status == 200) {
					this.refreshPlates();
					this.selected = [];
					this.$refs.gridTransportPayment.refresh();
					this.$fun.alert(`Se han generado ${paymentRecords.length} registros independientes para el pago de transportistas.`, "success");
					this.dialogXML = false;
					this.dialogCalculate = false;
				}
			} catch (error) {
				if (Object.keys(error).length > 0) {
					this.$fun.alert(error?.response?.data?.Message, "error");
				} else {
					this.$fun.alert(error.message, "error");
				}
			} finally {
				this.loadingCalculate = false;
				this.isValidatingXML = false;
			}
		},
		getDataForSave(group, costo, amountAditionals, javasExtras, invoiceNumber, pathInvoiceNumberXml, pathInvoiceNumberPdf, currentUserID, scheduleDetailID = null, harvestScheduleNumber = null) {
			const groupMoment = this.$moment(group.ScheduleDate);
			let data = {
				PymID: 0,
				RcsGngID: scheduleDetailID,
				HvsID: harvestScheduleNumber,
				ScheduleDate: group.ScheduleDate,
				VehID: group.PlateID,
				VehPlate: group.Plate,
				PymWeek: group.NumberWeek,
				PymReferralGuide: group?.ReferralGuide,
				PymServiceType: group.ServiceType, //SUNSHINE, MAQUILA
				PymProcessingPlant: group.ProcessingPlant, //SUNSHINE
				PymYear: groupMoment.year(),
				PymTypeTransport: group.TypeTransport,
				PymTypeTransportName: group.TypeTransportName,
				PymLocalityID: group._selectedLocaleID,
				PymZoneID: group._selectedZonID,
				PymZoneName: group._selectedZonName,
				PymZoneKM: group.ZoneDistanceKM,
				PymDestinationID: group.DestinationID,
				PymTypeCrop: group.TypeCrop, //2 : CONVENCIONAL
				PymTypeCultive: group.TypeCultive, //1 : MANGO
				PymVrtID: group.VarietyID, //1000: KENT
				PymRounds: group._rounds || 1,
				PymExtraJabas: javasExtras,
				PymAditionalAmount: amountAditionals,
				PymSubTotal: parseFloat(costo).toFixed(2),
				PymTotalPaid: (parseFloat(costo) + parseFloat(amountAditionals)).toFixed(2),
				PymTypeBaler: group?.PackerID || null,
				PymState: 1,
				PymNotes: null,
				UsrCreateID: currentUserID,
				PymInvoiceNumber: invoiceNumber,
				PymPathInvoiceNumberXml: pathInvoiceNumberXml,
				PymPathInvoiceNumberPdf: pathInvoiceNumberPdf,
				SecStatus: 1,
				PymID: group.PymID,
				PymOrdID: group.PymOrdID,
				PymOrdDocumentNumber: group.PymOrdDocumentNumber,
			};
			return data;
		},
		async loadPricesTransport() {
			const params = {
				filter: {}, draw: 1, start: 0, length: -1,
				order: [{ dir: "asc", column: "" }], searchText: "",
			};
			try {
				const response = await _sTransportPriceService.pagination(params, this.$fun.getUserID());
				return response.status === 200 ? response.data?.data : [];
			} catch (error) {
				return [];
			}
		},
		async loadPaymentsRecordGroup(PymPlatesID) {
			const filter = {
				DateBegin: this.filter.cDateInitial,
				DateEnd: this.filter.cDateFin,
				PymPlatesID
			}
			const params = {
				filter, draw: 1, start: 0, length: -1,
				order: [{ dir: "asc", column: "" }], searchText: "",
			};
			this.textLoading = "Calculando Precios...";
			this.loadingCalculate = true;
			try {
				const response = await _sTransportPaymentRecordService.pagination(params, this.$fun.getUserID());
				this.loadingCalculate = false;
				return response.status == 200 ? this.groupByPaymentRecords(response.data?.data) : [];
			} catch (error) {
				this.loadingCalculate = false;
				return [];
			}
		},
		groupByPaymentRecords(data) {
			const agrupado = data.reduce((acc, item) => {
				const fecha = item.ScheduleDate;
				const tipoTransporte = item.PymTypeTransport;
				const key = `${fecha}_${tipoTransporte}`;

				if (!acc[key]) {
					acc[key] = {
						ScheduleDate: fecha,
						PymTypeTransport: tipoTransporte,
						PymLocalityName: item.PymLocalityName,
						PymTypeTransportName: item.PymTypeTransportName,
						PymInvoiceNumber: item.PymInvoiceNumber,
						OrdDocumentNumber: item.OrdDocumentNumber,
						totalSubTotal: 0,
						totalAditional: 0,
						totalPaid: 0,
						totalCrateQuantity: 0,
						totalActualCrates: 0,
						cantidadRegistros: 0,
						items: []
					};
				}

				// 2. Realizar las sumas (convertir a Number por seguridad)
				acc[key].totalSubTotal += Number(item.PymSubTotal || 0);
				acc[key].totalAditional += item.PymTypeTransport == 1 ? Number(item.PymUnitExtraAmount || 0) : 0;
				acc[key].totalPaid += Number(item.PymTotalPaid || 0);
				acc[key].totalCrateQuantity += Number(item.CrateQuantity || 0);
				acc[key].totalActualCrates += Number(item.ActualCrates || 0);
				acc[key].cantidadRegistros += 1;
				acc[key].items.push(item);
				return acc;
			}, {});

			// 3. Convertir el objeto resultante en un Array
			return Object.values(agrupado);
		},
		restartFilter() {
			this.week = [];
			this.filter.cDateInitial = this.$moment().format("YYYY-MM-DD");
			this.filter.cDateFin = this.$moment().format("YYYY-MM-DD");
		},
		async savePDFGuia(records = []) {
			let paymentRecords = [...records];
			const cacheGuia = {};

			for (let i = 0; i < paymentRecords.length; i++) {
				// Solo busca GRE Emitidas de Fruta por Fascele, las demás nos emiten a nosotros
				if (paymentRecords[i].PymTypeTransport != 1) continue;
				const guideRecord = paymentRecords[i].PymReferralGuide;
				if (!guideRecord || guideRecord == undefined || guideRecord.toString().trim() === "") continue;

				if (cacheGuia[guideRecord]) {
					const cachedRes = cacheGuia[guideRecord];
					console.log({ cachedRes })
					if (cachedRes.success) {
						paymentRecords[i].PymPathReferralGuidePdf = cachedRes.fileName;
					}
				} else {
					try {
						const uploadedGuideFasele = await _sTransportPaymentRecordService.savePDFGuia(guideRecord, this.$fun.getUserID())
						cacheGuia[guideRecord] = uploadedGuideFasele.data;
						console.log({ uploadedGuideFasele, cacheGuia })
						if (uploadedGuideFasele.status == 200) {
							paymentRecords[i].PymPathReferralGuidePdf = uploadedGuideFasele.data.success ? uploadedGuideFasele.data.fileName : null;
						} else {
							console.log(uploadedGuideFasele?.data?.message || "Error al descargar la guía " + guideRecord)
						}
					} catch (error) {
						console.log("Error al descargar la guía savePDFGuia", error);
						// if (Object.keys(error).length > 0) {
						// 	this.$fun.alert(error?.response?.data?.Message, "error");
						// } else {
						// 	this.$fun.alert(error.message, "error");
						// }
					}
				}
			}

			return paymentRecords;
		},
		async loadFileOnServer(model, fileName, paramRoute = "RutaAnexosSAP", overwrite = true) {
			try {
				const response = await _GenUploadFiles.upload(model, fileName.toUpperCase(), paramRoute, overwrite);
				console.log({ response })
				if (response.status == 200) {
					return {
						success: true,
						message: response.data.message,
						path: response.data.path,
						fileName: response.data.fileName,
					}
				} else {
					return {
						success: false,
						message: 'Error al subir archivo',
					}
				}
			} catch (error) {
				console.log("Error on loadFileOnServer: ", error);
				if (Object.keys(error).length > 0) {
					this.$fun.alert(error?.response?.data?.Message, "error");
				} else {
					this.$fun.alert(error.message, "error");
				}
			}
		},
		async getPaginationCenterCostsAsList() {
			const params = {
				filter: { Search: "" }, draw: 1, start: 0, length: -1,
				order: [{ dir: "asc", column: "" }], searchText: "",
			};
			const response = await _sCosteService.pagination(params, this.$fun.getUserID());
			return response.status == 200 ? response.data?.data : [];
		},
		groupDataByTransport(data) {
			return data.reduce((acc, item) => {
				const DistanceCounter = item.SectorKM > 35 ? 1 : 0;
				const hasAmbiguos = (item.PlateID == item.MaterialsPlateID) ? true : false;

				if (item.Plate) {
					acc.frutas.push({
						...item,
						_rounds: 1,
						TypeTransport: 1,
						TypeTransportName: 'FRUTA',
						TypeTransportNameAlias: 'JABAS',
						DistanceCounter,
						hasFruit: true,
						hasMaterials: hasAmbiguos,
						CodeResumen: this.getDateInt(item.ScheduleDate) + item.Plate + 'FRUTA' + item.Zone,
					});
				}

				if (item.MaterialsPlate) {
					acc.materiales.push({
						...item,
						_rounds: 1,
						TypeTransport: 2,
						TypeTransportName: 'MATERIALES',
						TypeTransportNameAlias: 'MATERIALES',
						DistanceCounter,
						hasFruit: hasAmbiguos,
						hasMaterials: true,
						PlateID: item.MaterialsPlateID,
						Plate: item.MaterialsPlate,
						TypeVehicleBrand: item.MaterialsPlateBrand,
						TypeVehicleBrandName: item.MaterialsPlateBrandName,
						RUC: item.MaterialsPlateRUC,
						BusinessName: item.MaterialsPlateBusinessName,
						CapacityMin: item.MaterialsPlateMin,
						CapacityMax: item.MaterialsPlateMax,
						ReferralGuide: item.MaterialsGuide,
						PymID: item.PymIDMat, // Usamos el ID de pago de materiales
						OrdID: item.OrdIDMat, // Usamos el ID de pago de materiales
						OrdDocumentNumber: item.OrdDocumentNumberMat, // Usamos el ID de pago de materiales
						CodeResumen: this.getDateInt(item.ScheduleDate) + item.MaterialsPlate + 'MATERIAL' + item.Zone,
					});
				}
				return acc;
			}, { frutas: [], materiales: [] });
		},
		async groupByPlates(data, dataTransportExtras = [], dataTransshipments = []) {
			const baseData = [...data.frutas, ...data.materiales];
			const dataPriceDatabase = await this.loadPricesTransport();

			let grouped = baseData.reduce((acc, item) => {
				const placa = item.Plate;

				if (!acc[placa]) {
					acc[placa] = {};
				}

				const claveInterna = `${parseInt(this.$moment(item.ScheduleDate).format('DDMMYYYY'))}_${item.TypeZonLocationID}_${item.TypeTransport}`;

				if (!acc[placa][claveInterna]) {
					acc[placa][claveInterna] = this.getGroupItem(item, item.TypeTransport == 1 ? 'success' : 'orange');
				}

				const detalle = acc[placa][claveInterna];
				detalle.totalCrateQuantity += Number(item.CrateQuantity || 0);
				detalle.totalActualCrates += this.getKeyTotalJabasTransport(item);
				if (item.TypeTransport == 1) detalle.hasMaterials = data.materiales.filter(x => x.PlateID == item.PlateID && this.$moment(item.ScheduleDate).format("YYYY-MM-DD") == this.$moment(x.ScheduleDate).format("YYYY-MM-DD")).length > 0;
				if (item.TypeTransport == 2) detalle.hasFruit = data.frutas.filter(x => x.PlateID == item.PlateID && this.$moment(item.ScheduleDate).format("YYYY-MM-DD") == this.$moment(x.ScheduleDate).format("YYYY-MM-DD")).length > 0;

				if ([2, 3].includes(item.TypeZonLocationID) && placa == "A2J884") {
					console.log(JSON.parse(JSON.stringify({ detalle })))
				}
				detalle.items.push(item);
				return acc;
			}, {});


			// 2. INTEGRAR TRANSPORTES EXTRAS
			if (dataTransportExtras.length > 0) {
				this.setearDataExtrasTransport(dataTransportExtras, grouped);
			}

			// 3. INTEGRAR TRASBORDOS
			if (dataTransshipments.length > 0) {
				this.setearDataTransfersTransport(dataTransshipments, grouped);
			}

			Object.keys(grouped).forEach(placa => {

				// if (placa == "A3L883") {
				// console.log(JSON.parse(JSON.stringify({ groupedPlate: grouped[placa] })))
				// }

				grouped[placa] = Object.values(grouped[placa]).map(x => {
					let g = {
						...x,
						CostoRango: this.getCostRange(x),
						DistanceCounter: this.getDistanceCounter(x),
					}

					g.ZoneDistanceKM = this.getZoneDistanceKM(g);
					const price = this.getPriceDatabase(g, dataPriceDatabase)
					const totalExtraCrates = (g._selectedLocaleID && g.TypeTransport == 1 && !g.Packer && g.totalActualCrates > g.CostoRango) ? (g.totalActualCrates - g.CostoRango) : 0;

					g.price = price;
					g._price = price?.Price || 0;
					g.totalExtraCrates = totalExtraCrates;
					g._priceAditional = price?.PriceAditional || 0;
					g._totalExtraAmount = (totalExtraCrates || 0) * (price?.PriceAditional || 0);

					g._subTotalAmount = this.getCostoItem(g);
					g._totalAmount = this.getCostoItem(g, true)
					if (placa == "AYS806") console.log(JSON.parse(JSON.stringify({ ...g })));

					return g
				});
			});

			return grouped;
		},
		getGroupItem(item, color) {
			return {
				key: `${item.Plate}_${parseInt(this.$moment(item.ScheduleDate).format('DDMMYYYY'))}_${item.TypeZonLocationID}_${item.TypeTransport}`,
				TypeTransport: item.TypeTransport,
				TypeTransportName: item.TypeTransportName,
				TypeTransportNameAlias: item.TypeTransport == 1 ? 'JABAS' : 'MATERIALES',
				ScheduleDate: item.ScheduleDate,
				HarvestScheduleNumber: item.HarvestScheduleNumber,
				ScheduleDetailID: item.ScheduleDetailID,
				NumberWeek: item.NumberWeek,
				TypeZonLocationID: item.TypeZonLocationID,
				Locality: item.Locality,
				ZoneID: item.ZoneID,
				Zone: item.Zone,
				SectorName: item?.SectorName,
				OriginalZone: item.OriginalZone,
				DistanceCounter: 0,
				ZoneDistanceKM: null,
				FarmAddress: item.FarmAddress,
				PlateID: item.PlateID,
				Plate: item.Plate,
				TypeVehicleBrand: item.TypeVehicleBrand,
				TypeVehicleBrandName: item.TypeVehicleBrandName,
				CapacityMin: item.CapacityMin,
				CapacityMax: item.CapacityMax,
				RUC: item.RUC,
				BusinessName: item.BusinessName,
				totalActualCrates: 0,
				totalExtraCrates: 0,
				totalAmountMaterialSunshine: 0,
				totalCrateQuantity: 0,
				TrcJabasHarvestedAditional: 0,
				Destination: item.Destination,
				DestinationID: item.DestinationID,
				TypeCultive: item.TypeCultive,
				Crop: item.Crop,
				Packer: item.Packer,
				VarietyID: item.VarietyID,
				Empaca: item.Packer,
				ServiceType: item.ServiceType,
				ProcessingPlant: item.ProcessingPlant,
				TypeCrop: item.TypeCrop,
				TypeCropName: item.TypeCropName,
				ReferralGuide: item.ReferralGuide,
				hasFruit: item.hasFruit,
				hasMaterials: item.hasMaterials,
				CostoRango: null,
				price: null,
				PymFixedCost: 0,
				PymID: item.PymID,
				PymOrdID: item.OrdID,
				PymOrdDocumentNumber: item.OrdDocumentNumber,
				// Transshipments: [],
				items: [],
				_subTotalAmount: 0,
				_totalAmount: 0,
				_totalExtraAmount: 0,
				_price: 0,
				_priceAditional: 0,
				_rounds: item._rounds,
				_note: '',
				_selectedLocaleID: item.TypeZonLocationID ? Number(item.TypeZonLocationID) : null,
				_selectedZonID: item.ZoneID ? Number(item.ZoneID) : null,
				_selectedZonName: item.Zone,
				_triggerPriceUpdate: false,
				_zonesGroup: [], // this.ZonesGroup[item.TypeZonLocationID] || [],
				Color: color,
				CodeResumen: item.CodeResumen,
				useSector: item.TypeZonLocationID == 1,
			};
		},
		getKeyTotalJabasTransport(item) {

			const fechaCorte = new Date(2021, 10, 2);
			const fechaRegistro = new Date(item.ScheduleDate);

			return (fechaRegistro >= fechaCorte) ? Number(item.ActualCrates || 0) : Number(item.CrateQuantity || 0);

			// Antes, me estaba duplicando las sumatoria de jabas en A2J884 para sem:12-2026
			return this.allItemsPagination.reduce((suma, row) => {
				const fechaCorte = new Date(2021, 10, 2);
				const fechaRegistro = new Date(item.ScheduleDate);

				// Verificamos primero los criterios comunes (Fecha y Placa)
				if (this.$moment(item.ScheduleDate).format("YYYY-MM-DD") == this.$moment(row.ScheduleDate).format("YYYY-MM-DD") && row.Plate == item.Plate) {

					if (fechaRegistro >= fechaCorte) {
						// Condición 1: Localidad Costo y suma Jabas Reales
						if (row.TypeZonLocationID == item.TypeZonLocationID) {
							return suma + (Number(row.ActualCrates) || 0);
						}
					} else {
						// Condición 2: Localidad y suma Cantidad Jabas
						if (row.OriginalTypeZonLocationID == item.OriginalTypeZonLocationID) {
							return suma + (Number(row.CrateQuantity) || 0);
						}
					}
				}

				return suma;
			}, 0);

			// return ((fechaRegistro >= fechaCorte) ? (item.ActualCrates || 0) : (item.CrateQuantity || 0));
		},
		getCostRange(group) {
			const fecha = new Date(group.ScheduleDate);

			// --- LÓGICA TAMBOGRANDE ---
			if (group.TypeZonLocationID == 1) {
				if (group.Packer == "EC") {
					if (group.TypeVehicleBrand == 1 && group.TypeTransport == 1) return 300;

					if (group.TypeVehicleBrand == 2 && group.TypeTransport == 1) {
						const placasEspeciales = ["T8I932", "T3E877"];
						if (placasEspeciales.includes(group.Plate)) return 1200;
						if (group.totalActualCrates < 600) return 400;
						if (group.totalActualCrates < 1200) return 600;
						return 1200;
					}

					if (group.TypeVehicleBrand == 1 && group.TypeTransport == 2) return 200;
					if (group.TypeVehicleBrand == 2 && group.TypeTransport == 2) return 400;

					//Trasbordo
					if (group.TypeTransport == 4) return group.CapacityMin;

					return "OtroCosto";
				}

				if (group.Packer == null || group.Packer == "") {
					// Comparación Fecha >= 12/12/2022
					if (fecha >= new Date(2022, 11, 12)) { // Meses en JS son 0-11 (11 = Diciembre)
						if (group.totalActualCrates >= 1000) return 700;
						if (group.totalActualCrates >= 800) return 600;
						return group.CapacityMin;
					}

					// Comparación Fecha >= 01/12/2021 Y Cap Max >= 1000
					if (fecha >= new Date(2021, 11, 1) && group.CapacityMax >= 1000) {
						if (group.totalActualCrates >= 900) return 700;
						if (group.totalActualCrates >= 800) return 600;
						return group.CapacityMin;
					}

					return group.CapacityMin;
				}

				return "OtraEm";
			}

			// --- LÓGICA MOTUPE ---
			if (group.TypeZonLocationID == 2) {
				if (group.totalActualCrates >= 1000) return 1000;
				if (group.totalActualCrates >= 900) return 900;
				if (group.totalActualCrates >= 800) return 800;
				if (group.totalActualCrates >= 750) return 750;
				if (group.totalActualCrates >= 700) return 700;
				if (group.totalActualCrates >= 600) return 600;
				return 500; // Por defecto para >= 500 según tu formula
			}

			// --- LÓGICA CASMA ---
			if (group.TypeZonLocationID == 3) {
				return group.totalActualCrates >= 900 ? 900 : 899;
			}

			return "OtraLocal";
		},
		getDistanceCounter(group) {
			// let distanceCounterNumber = Number.isNaN(Number(group.DistanceCounter)) ? 0 : Number(group.DistanceCounter);

			// const total = arreglo.reduce((acumulador, valorActual) => {
			// 	return acumulador + valorActual;
			// }, 0); // <-- Este 0 es el valor inicial

			// --- LÓGICA TAMBOGRANDE ---
			if (group.TypeZonLocationID == 1) {
				if (group.TypeTransport == 1) {
					// Equivale a SUMAR.SI(codFruta; CodResumen; ContadorDistancia)
					return group.items.reduce((sum, p) => sum + (Number.isNaN(Number(p.DistanceCounter)) ? 0 : Number(p.DistanceCounter)), 0);
				}

				if (group.TypeTransport == 3) {
					return "";
				}

				// Para el resto (Materiales) equivale a SUMAR.SI(CodMaterial; CodResumen; ContadorDistancia)
				return group.items.reduce((sum, p) => sum + (Number.isNaN(Number(p.DistanceCounter)) ? 0 : Number(p.DistanceCounter)), 0);
				// return group.items.reduce((sum, p) => sum + distanceCounterNumber, 0);
			}
			// --- LÓGICA CASMA ---
			if (group.TypeZonLocationID == 3) {
				if (group.TypeTransport == 2) {
					// Verificamos si existe al menos uno para cada zona (Equivale a CONTAR.SI.CONJUNTO > 0)
					const hasHuarmey = group.items.some(p => {
						return group.useSector ? p?.SectorName == "HUARMEY" : p?.Zone == "HUARMEY";
					});
					if (hasHuarmey) return "H";

					const hasYautan = group.items.some(p => {
						return group.useSector ? p?.SectorName == "YAUTAN" : p?.Zone == "YAUTAN";
					});
					if (hasYautan) return "Y";

					const hasSanta = group.items.some(p => {
						return group.useSector ? p?.SectorName == "SANTA" : p?.Zone == "SANTA";
					});
					if (hasSanta) return "J";

					return "O";
				}

				return "";
			}

			return "";
		},
		getZoneDistanceKM(group) {
			const contadorDistancia = Number.isNaN(Number(group.DistanceCounter)) ? 0 : Number(group.DistanceCounter);

			if (group.TypeZonLocationID == 1) {
				if (group.TypeTransport == 3) {
					return "";
				}
				return contadorDistancia > 0 ? 36 : 35;
			}
			return "";
		},
		getPriceDatabase(group, listaPrecios) {
			// Parámetros de entrada (mapeados de tu objeto de detalle)
			const rounds = group._rounds;
			const javas = group.totalActualCrates;
			const empaca = group.Empaca || "";
			let typeTransport = group.TypeTransport;
			let localityID = group._selectedLocaleID;
			let zoneKM = group.ZoneDistanceKM;
			let typeCultive = group.TypeCultive;
			let typeVehicleBrand = group.TypeVehicleBrand;

			const includeIGV = new Date(group.ScheduleDate) >= new Date('2024-11-04') ? 1 : 0;
			const preciosFrutaCasmaOrdenados = [...listaPrecios.filter(x => x.LocaleID == 3 && x.TypeTransport == 1)].sort((a, b) => b.Capacity - a.Capacity);

			// Replicamos las condiciones del WHERE del Procedure
			const coincidencias = listaPrecios.filter(p => {
				// Filtros básicos obligatorios
				if (p.IncludeIGV != includeIGV) return false;

				// Para TAMBOGRANDE usa el mismo precio para Fruta y Material (solo está config para fruta)
				if (localityID == 1 && typeTransport == 2) {
					typeTransport = 1;
				}

				if (p.TypeTransport != typeTransport) return false;

				// Caso Especial: Transporte Extra (5)
				if (typeTransport == 5) {
					return p.TypeVehicle == typeVehicleBrand;
				}

				// Filtros por Localidad (Motupe=2, Casma=3, Tambogrande=1)
				if (localityID == 2) { // MOTUPE
					if (p.LocaleID !== 2) return false;
					if (typeTransport == 1) return p.TypeCultive == typeCultive && p.Capacity == group.CostoRango;
					if (typeTransport == 2) return p.TypeVehicle == typeVehicleBrand;
					if (typeTransport == 4) return p.Capacity == javas;
				}
				else if (localityID == 3) { // CASMA

					if (p.LocaleID !== 3) return false;

					if (typeTransport == 1) {
						const tarifaEncontrada = preciosFrutaCasmaOrdenados.find(x => group.CostoRango >= x.Capacity);
						const tarifaRetornar = tarifaEncontrada || preciosFrutaCasmaOrdenados[preciosFrutaCasmaOrdenados.length - 1];
						return tarifaRetornar.TcpID == p.TcpID;
					}

					// if (typeTransport == 1) return preciosFrutaCasmaOrdenados.find(x => group.CostoRango >= x.Capacity);
					// if (typeTransport == 1) return p.Capacity == group.CostoRango;
					if (typeTransport == 2) {
						return group.useSector ? p.ZoneName == group.SectorName : p.ZonID == group._selectedZonID;
						// return p.ZonID == group._selectedZonID;
					}
				}
				else { // TAMBOGRANDE y Otros					

					// 1. Cuando No es TAMBOGRANDE (1), o no es (FRUTA[1], MAT.[2]), ZoneKm no se necesita
					if (localityID != 1 || ![1, 2].includes(typeTransport)) {
						zoneKM = null;
					}

					// 2. Cuando es TRANSP. EXTRA (5), no se necesita Localidad (precio igual para todos)
					if (typeTransport == 5) {
						localityID = null;
					}

					// 3. Si no es FRUTA (1), TypeCultive no se necesita
					if (typeTransport != 1) {
						typeCultive = null;
					}

					// 4. Si no es FRUTA (1) ni MAT. (2), TypeVehicleBrand no se necesita
					if (![1, 2].includes(typeTransport)) {
						typeVehicleBrand = null;
					}

					// 5. Si es TRASBORDO (4), se limpian Cultivo y Marca de Vehículo
					if (typeTransport == 4) {
						typeCultive = null;
						typeVehicleBrand = null;
					}

					// Filtros cruzados dinámicos
					const matchLocality = !localityID || p.LocaleID == localityID;
					const matchKM = !zoneKM || p.Km == zoneKM;
					const matchCultive = !typeCultive || p.TypeCultive == typeCultive;
					const matchVehicle = !typeVehicleBrand || p.TypeVehicle == typeVehicleBrand;

					// Lógica de Capacidad (Javas o group.CostoRango por Empaque)
					let matchCapacity = true;
					if (typeTransport == 4) {
						matchCapacity = p.Capacity == rounds; // javas;
					} else if (empaca !== "") {
						matchCapacity = p.Empaca == empaca && p.Capacity == group.CostoRango;
					}

					return matchLocality && matchKM && matchCultive && matchVehicle && matchCapacity;
				}

				return false;
			});

			// if (group.Plate == 'BAH752') {
			// 	console.log(JSON.parse(JSON.stringify(coincidencias)))
			// }

			// Retornar el primer resultado (equivalente al TOP 1 ... ORDER BY TcpID)
			if (coincidencias.length > 0) {
				const precio = coincidencias.sort((a, b) => a.TcpID - b.TcpID)[0];
				return {
					TcpID: precio.TcpID,
					Price: precio.Price,
					PriceAditional: precio.PriceAditional,
					TypeCalculate: precio.TypeCalculate,
					Code: precio.Code
				};
			}

			return null; // No se encontró precio configurado
		},
		async processCenterCostByTransport(groupedByPlates) {
			const summary = [];
			const dataCenterCosts = await this.getPaginationCenterCostsAsList();

			Object.keys(groupedByPlates).forEach(plate => {
				const plateGroups = groupedByPlates[plate];
				if (!Array.isArray(plateGroups)) return;

				// Agrupar por TypeTransport, Destino y Tipo de Cultivo para las sumatorias
				const plateTotals = plateGroups.reduce((acc, g) => {
					const type = g.TypeTransport || 1;
					const dest = g.DestinationID || 0;
					const crop = g.TypeCrop || 0;
					const key = `${type}_${dest}_${crop}`;

					if (!acc[key]) {
						acc[key] = {
							totalBase: 0,
							totalAditionals: 0,
							sample: g
						};
					}
					// Usamos el total con rounds pero SIN los extras sumados
					acc[key].totalBase += Number(this.getCostoItem(g, false));
					acc[key].totalAditionals += Number(((g.TypeTransport == 1) ? parseFloat(g._totalExtraAmount || 0) : 0).toFixed(2));
					return acc;
				}, {});

				Object.keys(plateTotals).forEach(key => {
					const data = plateTotals[key];
					const g = data.sample;
					const semana = `Sem-${String(g.NumberWeek).padStart(2, '0')}`;
					// const issueDate = g.ScheduleDate ? this.$moment(g.ScheduleDate).format("YYYY-MM-DD") : this.$moment().format("YYYY-MM-DD");

					// 1. Línea de Gasto Base
					if (data.totalBase > 0) {
						const total = Number(data.totalBase.toFixed(2));
						const net = Number((total / 1.18).toFixed(2));
						const account = this.getAccount(g, dataCenterCosts);
						// console.log(JSON.parse(JSON.stringify({ account })))

						summary.push({
							Plate: g.Plate,
							BusinessName: g.BusinessName,
							Ruc: g.RUC,
							InvoiceNumber: "",
							IssueDate: null,
							GastoType: g.TypeTransportNameAlias || 'JABAS',
							Account: account?.CsaAccount, // '6092102'
							AccountDetail: account?.CsaAccountName, // 'Transporte de Materia Prima - TE'
							TotalAmount: total,
							NetValue: net,
							CostCenter: account?.CceID || '',
							Line: account?.BslID || '',
							Provision: "CV",
							Semana: semana
						});
					}

					// 2. Línea de Gasto Adicional (Adicionales)
					if (data.totalAditionals > 0) {
						const total = Number(data.totalAditionals.toFixed(2));
						const net = Number((total / 1.18).toFixed(2));
						const account = this.getAccount(g, dataCenterCosts, true);
						// console.log(JSON.parse(JSON.stringify({ account })))
						// const accountBase = this.getAccount(g, dataCenterCosts); // Fallback para CC y Línea del viaje base

						summary.push({
							Plate: g.Plate,
							BusinessName: g.BusinessName,
							Ruc: g.RUC,
							InvoiceNumber: "",
							IssueDate: null,
							GastoType: g.TypeTransportNameAlias || 'JABAS',
							Account: account?.CsaAccount,
							AccountDetail: account?.CsaAccountName,
							TotalAmount: total,
							NetValue: net,
							CostCenter: account?.CceID || '',
							Line: account?.BslID || '',
							Provision: "CV",
							Semana: semana
						});
					}
				});
			});

			return summary;
		},
		getAccount(group, allItemsCenterCosts = [], isExtras = false) {

			const typeCoste = this.setTypetransportToTypeCost(group.TypeTransport, isExtras);
			const account = allItemsCenterCosts.find(g =>
				g.TypeZonLocation == group._selectedLocaleID &&
				g.TypeCoste == typeCoste &&
				g.TypeShip == group.DestinationID &&
				g.Cultive == group.TypeCultive &&
				(typeCoste == 4 || g.TypeCultive == group.TypeCrop)
			);
			// if (isExtras) {
			// console.log(JSON.parse(JSON.stringify({ account, typeCoste })))
			// }
			return account;
		},
		setTypetransportToTypeCost(typeTransport, isExtras = false) {
			if (isExtras) return 3;
			if (typeTransport == 3) return 4; //PERSONAL - MATERIAL
			if (typeTransport == 4) return 4; //TRANSB. - TRANSP. EXTRA
			if (typeTransport == 5) return 4; //TRANSP. EXTRA - TRANSP. EXTRA
			return typeTransport;
		},
		async getDataTransbordsAndExtras(StrPlatesVeh = "") {

			const filter = {
				DateBegin: this.filter.cDateInitial,
				DateEnd: this.filter.cDateFin,
				PlatesVeh: StrPlatesVeh
			}
			const paramsPage = {
				filter: filter,
				draw: 1, start: 0, length: -1,
				order: [{ dir: "asc", column: "" }],
				searchText: "",
			}

			const [resultTrsbd, resultExtr] = await Promise.all([
				_sReceptionTransfer.pagination(paramsPage, this.$fun.getUserID()),
				_sTasExtraTransportService.pagination(paramsPage, this.$fun.getUserID()),
			]);

			const transshipments = resultTrsbd.status == 200 ? resultTrsbd.data?.data : [];
			const extraTransports = resultExtr.status == 200 ? resultExtr.data?.data : [];
			return [transshipments, extraTransports];
		},
		setearDataExtrasTransport(dataTransportExtras = [], grouped = []) {

			dataTransportExtras.forEach(item => {
				const placa = item.VehPlate;
				if (!grouped[placa]) grouped[placa] = {};

				// Buscar grupo base del mismo día para heredar contexto (Localidad, Zona, etc.)
				const baseGroup = Object.values(grouped[placa]).find(x => this.$fun.formatDateView(x.ScheduleDate) == this.$fun.formatDateView(item.ScheduleDate) && [1, 2].includes(x.TypeTransport)) || {};

				let g = {
					...baseGroup,
					...item,
					Plate: item.VehPlate,
					TypeTransport: item.TransportTypeID,
					TypeTransportName: item.TypeTransportName,
					TypeTransportNameAlias: 'MATERIALES',
					DistanceCounter: 0,
					CrateQuantity: 0,
					ActualCrates: 0,
					PymFixedCost: item.AgreedPrice,
					PymID: baseGroup?.items?.length ? baseGroup?.items[0].PymIDExt : null,
					OrdID: baseGroup?.items?.length ? baseGroup?.items[0].OrdIDExt : null,
					OrdDocumentNumber: baseGroup?.items?.length ? baseGroup?.items[0].OrdDocumentNumberExt : null,
					_rounds: item.Rounds || 1,
					hasFruit: false,
					hasMaterials: false,
					items: [],
					CodeResumen: this.getDateInt(baseGroup?.ScheduleDate) + placa + 'MATERIALEXTRA' + baseGroup?.Zone,
				}

				const claveInterna = `${g.ScheduleDate}_${g.TypeZonLocationID}_${g.TypeTransport}`;
				if (!grouped[placa][claveInterna]) {
					grouped[placa][claveInterna] = this.getGroupItem(g, 'blue');
				}

				const detalle = grouped[placa][claveInterna];
				// Nota: detalle es una referencia al objeto en grouped[placa][claveInterna]
				detalle.totalCrateQuantity += Number(g.CrateQuantity || 0);
				detalle.totalActualCrates += Number(g.ActualCrates || 0);
				detalle.items.push(g);
			});

			return grouped;
		},
		setearDataTransfersTransport(dataTransshipments = [], grouped = []) {

			dataTransshipments.forEach(item => {
				const placa = item.VehPlate;
				if (!grouped[placa]) grouped[placa] = {};

				// Buscar grupo base del mismo día para heredar contexto (Localidad, Zona, etc.)
				const baseGroup = Object.values(grouped[placa]).find(x => this.$fun.formatDateView(x.ScheduleDate) == this.$fun.formatDateView(item.TransferDate) && [1, 2].includes(x.TypeTransport)) || {};
				const counterEqualsPlate = dataTransshipments.filter(x => x.VehPlate == item.VehPlate);

				let g = {
					...baseGroup,
					...item,
					Plate: item.VehPlate,
					TypeTransport: 4,
					TypeTransportName: "TRASBORDO",
					TypeTransportNameAlias: 'MATERIALES',
					DistanceCounter: 0,
					CrateQuantity: 0,
					ActualCrates: item.TransferQuantity,
					PymFixedCost: 0,
					PymID: baseGroup?.items?.length ? baseGroup?.items[0].PymIDTrasb : null,
					OrdID: baseGroup?.items?.length ? baseGroup?.items[0].OrdIDTrasb : null,
					OrdDocumentNumber: baseGroup?.items?.length ? baseGroup?.items[0].OrdDocumentNumberTrasb : null,
					_rounds: counterEqualsPlate.length || 1,
					hasFruit: false,
					hasMaterials: false,
					items: [],
					CodeResumen: this.getDateInt(baseGroup?.ScheduleDate) + placa + 'TRASBORDO' + baseGroup?.Zone,
					// Transshipments: [...counterEqualsPlate],
				}

				const claveInterna = `${g.TransferDate}_${g.TypeZonLocationID}_${g.TypeTransport}`;
				if (!grouped[placa][claveInterna]) {
					grouped[placa][claveInterna] = this.getGroupItem(g, 'purple');
				}

				const detalle = grouped[placa][claveInterna];
				// Nota: detalle es una referencia al objeto en grouped[placa][claveInterna]
				detalle.totalCrateQuantity += Number(g.CrateQuantity || 0);
				detalle.totalActualCrates += Number(g.ActualCrates || 0);
				detalle.items.push(g);
			});

			return grouped;
		},
		async getZonesByLocation(items = []) {
			const uniqueLocales = [...new Set(items.map(g => g.TypeZonLocationID).filter(Boolean))].map(Number);
			const zonesCache = {};
			await Promise.all(uniqueLocales.map(async (locId) => {
				const parameters = { TypeZon: locId };
				try {
					const response = await _sTasGroupZonService.GetZonesByGroup(parameters, this.$fun.getUserID());
					zonesCache[locId] = response.status == 200 ? response.data : [];
				} catch (e) {
					zonesCache[locId] = [];
				}
			}));

			return zonesCache;
		},
		async exportarProvisionesExcel() {

			const dataPagination = await this.getPaginationAsList(1);

			const platesMap = new Map();
			const state = this.filter.cStatePayment || 0;

			dataPagination.forEach(item => {
				// Evaluar Placa de Fruta
				if (item.Plate && item.Plate.trim() !== '') {
					let include = true;
					if (state > 0) {
						const pymId = item.PymID || 0;
						const ordId = item.OrdID || 0;
						if (state == 1) include = (pymId == 0 && ordId == 0);
						else if (state == 2) include = (pymId > 0 && ordId == 0);
						else if (state == 3) include = (pymId > 0 && ordId > 0);
					}
					if (include) {
						const p = item.Plate.trim();
						if (!platesMap.has(p)) platesMap.set(p, { Plate: p, Records: 0 });
						platesMap.get(p).Records++;
					}
				}

				// Evaluar Placa de Materiales
				if (item.MaterialsPlate && item.MaterialsPlate.trim() !== '') {
					let include = true;
					if (state > 0) {
						const pymIdMat = item.PymIDMat || 0;
						const ordIdMat = item.OrdIDMat || 0;
						if (state == 1) include = (pymIdMat == 0 && ordIdMat == 0);
						else if (state == 2) include = (pymIdMat > 0 && ordIdMat == 0);
						else if (state == 3) include = (pymIdMat > 0 && ordIdMat > 0);
					}
					if (include) {
						const p = item.MaterialsPlate.trim();
						if (!platesMap.has(p)) platesMap.set(p, { Plate: p, Records: 0 });
						platesMap.get(p).Records++;
					}
				}
			});

			if (dataPagination.length == 0) {
				this.$fun.alert(`NO SE ENCONTRARON REGISTROS.`, "warning");
				return;
			}

			const grupos = this.groupDataByTransport(dataPagination);
			const baseData = [...grupos.frutas.map(x => x.Plate), ...grupos.materiales.map(x => x.Plate)];
			const platesVehStr = [...new Set(baseData)].filter(x => x != null && x != '').join(",");
			const [transshipments, extraTransports] = await this.getDataTransbordsAndExtras(platesVehStr);
			const groupByplate = await this.groupByPlates(grupos, extraTransports, transshipments);

			const keys = Object.keys(groupByplate);
			const allRecordsPromises = keys.map(k => this.loadPaymentsRecordGroup(k).then(records => records.map(r => ({ ...r, _tempPlateKey: k }))));
			const selectedPaymentRecords = (await Promise.all(allRecordsPromises)).flat();

			keys.forEach(k => {
				Object.values(groupByplate[k]).forEach(x => {
					const typetransport = x.TypeTransport;
					const sheduledate = this.$fun.formatDateView(x.ScheduleDate);
					const PaymentRecord = selectedPaymentRecords.find(r => r._tempPlateKey == k && this.$fun.formatDateView(r.ScheduleDate) == sheduledate && r.PymTypeTransport == typetransport);

					this.$set(x, "isSaved", PaymentRecord !== undefined);
					this.$set(x, "PaymentRecord", PaymentRecord);
				});
			});


			// Filtrar groupByplate para que solo vayan los datos que tengan isSaved = false
			Object.keys(groupByplate).forEach(k => {
				const unsaved = Object.values(groupByplate[k]).filter(x => x.isSaved === false);
				if (unsaved.length > 0) {
					groupByplate[k] = unsaved;
				} else {
					delete groupByplate[k]; // Eliminar la placa si todos sus registros ya están guardados
				}
			});

			// console.log(JSON.parse(JSON.stringify({ groupByplate })))
			const rawData = await this.processCenterCostByTransport(groupByplate);

			const workbook = new ExcelJS.Workbook();
			const groupedData = rawData.reduce((acc, item) => {
				if (!acc[item.Semana]) acc[item.Semana] = [];
				acc[item.Semana].push(item);
				return acc;
			}, {});

			const sortedWeeks = Object.keys(groupedData).sort();

			sortedWeeks.forEach(weekName => {
				// Generar color aleatorio para el tab de la hoja
				const randomColor = Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0').toUpperCase();
				const worksheet = workbook.addWorksheet(weekName, { properties: { tabColor: { argb: 'FF' + randomColor } } });
				const dataSemana = groupedData[weekName];

				// 1. DEFINICIÓN DE COLUMNAS (Mantenemos las keys pero sin renderizar cabecera automática)
				worksheet.columns = [
					{ key: "empty", width: 2 },
					{ key: "Plate", width: 10 },
					{ key: "BusinessName", width: 38 },
					{ key: "Ruc", width: 12 },
					{ key: "InvoiceNumber", width: 12 },
					{ key: "IssueDate", width: 11 },
					{ key: "GastoType", width: 11 },
					{ key: "Account", width: 9 },
					{ key: "AccountDetail", width: 28 },
					{ key: "TotalAmount", width: 12 },
					{ key: "NetValue", width: 14 },
					{ key: "CostCenter", width: 13 },
					{ key: "Line", width: 8 },
					{ key: "Provision", width: 12 }
				];

				// 2. TÍTULO (Fila 7)
				worksheet.getCell('B2').value = "RELACIÓN DE FACTURAS DE TRANSPORTE POR PROVICIONAR";
				worksheet.getCell('B2').font = { name: 'Arial', bold: true, size: 12 };

				// 3. CABECERA MANUAL CORREGIDA (Fila 4) - Sin fondo y con bordes
				const headerRow = worksheet.getRow(4);
				const headerLabels = [
					"", "PLACA", "RAZON SOCIAL", "RUC", "FACTURA", "FECHA EMISION",
					"GASTO", "CTA", "DETALLE CTA", "TOTAL", "VALOR VENTA",
					"CENTRO DE COSTO", "LINEA", "TIPO DE COSTO"
				];

				headerLabels.forEach((label, index) => {
					const cell = headerRow.getCell(index + 1);
					cell.value = label;
					if (index > 0) { // Ignorar columna A
						cell.font = { bold: true, color: { argb: 'FF000000' }, size: 8 };
						cell.fill = { type: 'pattern', pattern: 'none' };
						cell.alignment = { vertical: 'middle', horizontal: 'center' };
						cell.border = {
							top: { style: 'thin' }, left: { style: 'thin' },
							bottom: { style: 'thin' }, right: { style: 'thin' }
						};
					}
				});

				// 4. AGREGAR DATOS
				let sumTotal = 0;
				let sumNet = 0;
				dataSemana.forEach((item) => {
					const totalVal = Number(item.TotalAmount) || 0;
					const netVal = Number(item.NetValue) || 0;
					sumTotal += totalVal;
					sumNet += netVal;

					const row = worksheet.addRow({
						empty: "",
						Plate: item.Plate,
						BusinessName: item.BusinessName,
						Ruc: item.Ruc,
						InvoiceNumber: item.InvoiceNumber,
						IssueDate: item.IssueDate ? new Date(item.IssueDate.split('-')[0], item.IssueDate.split('-')[1] - 1, item.IssueDate.split('-')[2]) : null,
						GastoType: item.GastoType,
						Account: item.Account,
						AccountDetail: item.AccountDetail,
						TotalAmount: totalVal,
						NetValue: netVal,
						CostCenter: item.CostCenter,
						Line: item.Line,
						Provision: item.Provision
					});

					// 5. ESTILOS DE FILAS (Bordes y Colores)
					row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
						if (colNumber > 1 && colNumber <= 14) {
							cell.border = {
								top: { style: 'thin' }, left: { style: 'thin' },
								bottom: { style: 'thin' }, right: { style: 'thin' }
							};

							// Fuente tamaño 8 para toda la tabla
							cell.font = { size: 8 };

							// FACTURA (Columna 5) - Fondo Amarillo / Naranja según contenido
							if (colNumber == 5) {
								const invVal = (item.InvoiceNumber || '').toString().trim().toUpperCase();
								const hasInvoice = invVal !== '' && invVal !== '';
								cell.fill = {
									type: 'pattern',
									pattern: 'solid',
									fgColor: { argb: hasInvoice ? 'FFFFFF00' : 'FFFFC000' }
								};
							}

							// FECHA (Columna 6) - Formato d-mmm-yy
							if (colNumber == 6) {
								cell.numFmt = 'd-mmm-yy';
								cell.alignment = { horizontal: 'right', vertical: 'middle' };
							}

							// ALINEACIÓN CENTRADA para Factura (5), Linea (13) y Tipo de Costo (14)
							if ([5, 13, 14].includes(colNumber)) {
								cell.alignment = { horizontal: 'center', vertical: 'middle' };
							}

							// TOTAL (Columna 10) - Fondo #F2DCDB
							if (colNumber == 10) {
								cell.fill = {
									type: 'pattern',
									pattern: 'solid',
									fgColor: { argb: 'FFF2DCDB' }
								};
							}

							if (colNumber == 10 || colNumber == 11) {
								cell.numFmt = '#,##0.00';
								cell.alignment = { horizontal: 'right' };
							}
						}
					});
				});

				// 6. FILA DE SUMATORIA FINAL
				const totalRow = worksheet.addRow({
					empty: "",
					Plate: "", BusinessName: "", Ruc: "", InvoiceNumber: "", IssueDate: "",
					GastoType: "", Account: "", AccountDetail: "",
					TotalAmount: sumTotal,
					NetValue: sumNet,
					CostCenter: "", Line: "", Provision: ""
				});

				totalRow.eachCell((cell, colNumber) => {
					if (colNumber == 10 || colNumber == 11) { // SOLO TOTAL y VALOR VENTA
						cell.font = { bold: true, size: 10 };
						cell.border = {
							top: { style: 'thick' }, left: { style: 'thin' },
							bottom: { style: 'thick' }, right: { style: 'thin' }
						};
						cell.numFmt = '#,##0.00';
						cell.alignment = { horizontal: 'right' };
					}
				});

				// 6. FINALIZACIÓN
				worksheet.autoFilter = 'B4:N4';
				worksheet.views = [
					{
						state: 'frozen',
						xSplit: 10,
						ySplit: 4,
						zoomScale: 120,
						showGridLines: true
					}
				];
			});

			const buffer = await workbook.xlsx.writeBuffer();
			saveAs(new Blob([buffer]), `PROVISIONES_FINAL_SUNEXPERT_SEM_${this.filter.PymWeek}_${this.filter.PymYear}.xlsx`);
		},
		async exportarExcel() {

			const dataPagination = await this.getPaginationAsList();
			if (dataPagination.length == 0) {
				this.$fun.alert(`NO SE ENCONTRARON REGISTROS.`, "warning");
				return;
			}

			const grupos = this.groupDataByTransport(dataPagination);
			const baseData = [...grupos.frutas.map(x => x.Plate), ...grupos.materiales.map(x => x.Plate)];
			const platesVehStr = [...new Set(baseData)].filter(x => x != null && x != '').join(",");
			const [transshipments, extraTransports] = await this.getDataTransbordsAndExtras(platesVehStr);
			const groupByplate = await this.groupByPlates(grupos, extraTransports, transshipments);
			console.log(JSON.parse(JSON.stringify({ groupByplate })))
			const summary = Object.values(groupByplate).flat();

			const workbook = new ExcelJS.Workbook();
			const worksheet = workbook.addWorksheet("CONSOLIDADO");

			// 1. DEFINICIÓN DE COLUMNAS 
			worksheet.columns = [
				{ key: "TypeTransportName", width: 13 },
				{ key: "SheduleDate", width: 12 },
				{ key: "NumberWeek", width: 10 },
				{ key: "Crop", width: 10 },
				{ key: "TypeCropName", width: 15 },
				{ key: "Destination", width: 12 },
				{ key: "Locality", width: 15 },
				{ key: "Zone", width: 15 },
				{ key: "FarmAddress", width: 30 },
				{ key: "ZoneDistanceKM", width: 7 },
				{ key: "Plate", width: 9 },
				{ key: "TypeVehicleBrandName", width: 10 },
				{ key: "RUC", width: 12 },
				{ key: "BusinessName", width: 30 },
				{ key: "totalActualCrates", width: 12 },
				{ key: "CostoRango", width: 10 },
				{ key: "totalExtraCrates", width: 12 },
				{ key: "SubTotalAmount", width: 12 },
				{ key: "TotalExtraAmount", width: 12 },
				{ key: "PymFixedCost", width: 12 },
				{ key: "TotalAmount", width: 12 },
			];

			// 2. CABECERA (Fila 1) - Sin fondo y con bordes
			const headerRow = worksheet.getRow(1);
			const headerLabels = [
				"TIPO CARGA", "FECHA.", "SEMANA", "CULTIVO", "TIPO DE CULTIVO", "DESTINO", "LOCALIDAD", "ZONA", "DIRECCIÓN", "KM",
				"PLACA", "TIPO VEHICULO", "RUC", "RAZON SOCIAL", "JABAS REALES", "RANGO COSTO", "JABAS EXTRAS", "SUB TOTAL", "TOTAL EXTRAS", "COSTO ACORDADO", "TOTAL"
			];

			headerLabels.forEach((label, index) => {
				const cell = headerRow.getCell(index + 1);
				cell.value = label;
				cell.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 9 };
				cell.fill = {
					type: 'pattern',
					pattern: 'solid',
					fgColor: { argb: 'FF2F75B5' } // Azul corporativo oscuro
				};
				cell.alignment = { vertical: 'middle', horizontal: 'center' };
				cell.border = {
					top: { style: 'thin' }, left: { style: 'thin' },
					bottom: { style: 'thin' }, right: { style: 'thin' }
				};
			});

			// 3. AGREGAR DATOS
			let sumTotal = 0;
			summary.forEach((item) => {
				const totalVal = this.getCostoItem(item, true) || 0;
				sumTotal += totalVal;

				const row = worksheet.addRow({
					TypeTransportName: item.TypeTransportName,
					SheduleDate: item.ScheduleDate ? this.$moment(item.ScheduleDate).toDate() : null,
					NumberWeek: String(item.NumberWeek).padStart(2, '0'),
					Crop: item.Crop,
					TypeCropName: item.TypeCropName,
					Destination: item.DestinationName || item.Destination,
					Locality: item.Locality,
					Zone: item._selectedZonName,
					FarmAddress: item.FarmAddress,
					ZoneDistanceKM: item.ZoneDistanceKM,
					Plate: item.Plate,
					TypeVehicleBrandName: item.TypeVehicleBrandName,
					RUC: item.RUC,
					BusinessName: item.BusinessName,
					totalActualCrates: Number(item.totalActualCrates) || 0,
					CostoRango: item.CostoRango,
					totalExtraCrates: Number(item.totalExtraCrates) || 0,
					SubTotalAmount: Number(item._subTotalAmount) || 0,
					TotalExtraAmount: Number(item._totalExtraAmount) || 0,
					PymFixedCost: Number(item.PymFixedCost || 0) || 0,
					TotalAmount: Number(item._totalAmount || 0) || 0,
				});


				// 5. ESTILOS DE FILAS (Bordes y Colores)
				row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
					if (colNumber >= 1 && colNumber <= 21) {
						cell.border = {
							top: { style: 'thin', color: { argb: 'FFBFBFBF' } },
							left: { style: 'thin', color: { argb: 'FFBFBFBF' } },
							bottom: { style: 'thin', color: { argb: 'FFBFBFBF' } },
							right: { style: 'thin', color: { argb: 'FFBFBFBF' } }
						};

						// Fondo intercalado (Zebra striping)
						cell.fill = {
							type: 'pattern',
							pattern: 'solid',
							fgColor: { argb: row.number % 2 === 0 ? 'FFDDEBF7' : 'FFFFFFFF' }
						};

						// Fuente tamaño 8 para toda la tabla
						cell.font = { size: 8, name: 'Calibri' };

						// FECHA (Columna 2) - Formato d-mmm-yy
						if (colNumber == 2 && cell.value) {
							cell.numFmt = 'd-mmm';
							cell.alignment = { horizontal: 'center', vertical: 'middle' };
						}

						// ALINEACIÓN CENTRADA
						if ([1, 3, 4, 5, 6, 7, 8, 10, 11, 12, 13, 15].includes(colNumber)) {
							cell.alignment = { horizontal: 'center', vertical: 'middle' };
						}

						// ALINEACIÓN IZQUIERDA para dirección (9) y razón social (14)
						if ([9, 14].includes(colNumber)) {
							cell.alignment = { horizontal: 'left', vertical: 'middle' };
						}

						// TOTALES NUMÉRICOS (Columnas 16 al 21)
						if (colNumber >= 16 && colNumber <= 21) {
							cell.numFmt = '#,##0.00';
							cell.alignment = { horizontal: 'right' };
						}

						// TOTAL (Columna 21) - Fondo Rosado/Naranja (Sobrescribe el azul)
						if (colNumber == 21) {
							cell.fill = {
								type: 'pattern',
								pattern: 'solid',
								fgColor: { argb: 'FFF2DCDB' }
							};
						}
					}
				});
			});

			// 4. FILA DE SUMATORIA FINAL
			// const totalRow = worksheet.addRow({
			// 	TypeTransportName: "", SheduleDate: "", NumberWeek: "", Crop: "", TypeCropName: "", Destination: "", Locality: "", Zone: "", FarmAddress: "",
			// 	ZoneDistanceKM: "", Plate: "", TypeVehicleBrandName: "", CostoRango: "", RUC: "", BusinessName: "", totalActualCrates: "", totalExtraCrates: "",
			// 	SubTotalAmount: "", TotalExtraAmount: "", PymFixedCost: "", TotalAmount: sumTotal,
			// });

			// totalRow.eachCell((cell, colNumber) => {
			// 	if (colNumber == 21) { // SOLO TOTAL
			// 		cell.font = { bold: true, size: 10 };
			// 		cell.border = {
			// 			top: { style: 'thick' }, left: { style: 'thin' },
			// 			bottom: { style: 'thick' }, right: { style: 'thin' }
			// 		};
			// 		cell.numFmt = '#,##0.00';
			// 		cell.alignment = { horizontal: 'right' };
			// 	}
			// });

			// 5. FINALIZACIÓN
			worksheet.autoFilter = 'A1:U1';
			worksheet.views = [
				{
					state: 'frozen',
					ySplit: 1,
					zoomScale: 120,
					showGridLines: true
				}
			];

			const buffer = await workbook.xlsx.writeBuffer();
			saveAs(new Blob([buffer]), `PRECIOS_GENERADOS_SUNEXPERT_SEM_${this.filter.PymWeek}_${this.filter.PymYear}.xlsx`);
		}
	},
};
</script>

<style scoped>
.header-premium {
	background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
	/* border-bottom: 4px solid #1e3a8a; */
}

.filter-top-bar {
	z-index: 100;
	position: relative;
}

.panel-header {
	background: white;
}

.panel-footer {
	background: #f8fafc;
}

.stat-pill {
	background: #f1f5f9;
	border-radius: 0.625rem;
	padding: 4px 8px;
	margin-right: 8px;
	display: flex;
	align-items: center;
	border: 1px solid #e2e8f0;
}

.stat-pill .label {
	font-size: 8px;
	font-weight: 700;
	color: #64748b;
	margin-right: 6px;
	text-transform: uppercase;
}

.stat-pill .value {
	font-size: 14px;
	font-weight: 900;
	color: #1e293b;
}

.premium-search-refined :deep(.v-input__control .v-input__slot) {
	background: white !important;
	border-radius: 10px !important;
}

.bg-light-sky {
	background-color: #f0f9ff;
}

.premium-table-workspace th {
	background-color: #f8fafc !important;
	font-size: 11px !important;
	font-weight: 800 !important;
	color: #475569 !important;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	border-bottom: 2px solid #e2e8f0 !important;
}

.premium-table-workspace td {
	font-size: 12px !important;
}

/* ── Iconos y Badges ── */
.premium-icon-box {
	background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
	padding: 10px;
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 4px 12px rgba(30, 41, 59, 0.15);
}

.premium-icon-box.primary {
	background: linear-gradient(135deg, #2563eb 0%, #3b82f6 100%);
	box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
}

.mini-badge :deep(.v-badge__badge) {
	font-weight: 800;
	font-size: 10px;
	height: 18px;
	min-width: 18px;
	padding: 4px;
}

/* ── Inputs Premium ── */
.filter-label {
	display: block;
	font-size: 11px;
	font-weight: 800;
	color: #64748b;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	margin-bottom: 8px;
	padding-left: 4px;
}

.filter-group {
	margin-bottom: 12px;
}

:deep(.premium-input .v-input__control .v-input__slot) {
	border-radius: 10px !important;
	border-color: #e2e8f0 !important;
	background: #f8fafc !important;
	transition: all 0.2s ease;
}

:deep(.premium-input .v-input--is-focused .v-input__slot) {
	background: white !important;
	border-color: #3b82f6 !important;
	box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
}

.premium-search :deep(.v-input__slot) {
	border-radius: 12px !important;
	background: white !important;
}

/* ── Vehículos / Cards ── */
.vehicle-card {
	background: white;
	border-radius: 12px;
	padding: 4px;
	margin-bottom: 2px;
	cursor: pointer;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	border: 1px solid #e2e8f0;
	display: flex;
	align-items: center;
}

.vehicle-card:hover {
	transform: translateY(-2px);
	box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);
	border-color: #cbd5e1;
}

.vehicle-card.active {
	background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
	border-color: transparent;
	box-shadow: 0 12px 20px -5px rgba(37, 99, 235, 0.3);
}

.vehicle-card.active .plate-number {
	color: white !important;
}

.vehicle-card.active .plate-info {
	color: rgba(255, 255, 255, 0.8) !important;
}

.plate-avatar {
	width: 32px;
	height: 32px;
	border-radius: 8px;
	background: #eff6ff;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.3s ease;
}

.vehicle-card.active .plate-avatar {
	background: rgba(255, 255, 255, 0.2);
}

.plate-number {
	font-weight: 900;
	color: #1e293b;
	font-size: 0.95rem;
	letter-spacing: 0.02em;
}

.plate-info {
	font-size: 11px;
	color: #64748b;
	font-weight: 600;
}

/* ── Main Layout Elements ── */
.premium-table-container {
	padding: 12px 16px;
	border-bottom: 1px solid #e2e8f0;
	z-index: 1;
}

.premium-table-container {
	border-radius: 16px !important;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	border: 1px solid #e2e8f0 !important;
	box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.03) !important;
}

/* ── Tablas Premium ── */
.premium-table {
	background: white !important;
}

.premium-table :deep(th) {
	background: #f1f5f9 !important;
	color: #475569 !important;
	font-weight: 800 !important;
	text-transform: uppercase;
	font-size: 10px !important;
	letter-spacing: 0.05em;
	height: 44px !important;
	border-bottom: 2px solid #e2e8f0 !important;
}

.premium-table :deep(td) {
	height: 60px !important;
	border-bottom: 1px solid #f1f5f9 !important;
}

.premium-row:hover {
	background-color: #f8fafc !important;
}



.highlight-blue {
	background: #eff6ff !important;
	color: #2563eb !important;
}

.highlight-blue-cell {
	background: #f8fafc;
	color: #2563eb;
	border-left: 2px solid #dbeafe !important;
}

.highlight-orange-cell {
	background: #fff7ee;
	color: #f97316;
	border-left: 2px solid #ffe9d6 !important;
}

.highlight-green {
	background: #f0fdf4 !important;
	color: #166534 !important;
}

.highlight-green-cell {
	background: #f0fdf4;
	color: #15803d;
	border-left: 2px solid #dcfce7 !important;
}

.final-price {
	font-weight: 900;
	font-size: 1.1rem;
}

.premium-inner-select :deep(.v-input__slot) {
	border-radius: 8px !important;
	font-size: 11px !important;
	min-height: 30px !important;
}

.premium-inner-input :deep(.v-input__slot) {
	border-radius: 8px !important;
	background-color: white !important;
	font-size: 12px !important;
	min-height: 30px !important;
}

.details-table :deep(th),
.details-table :deep(td) {
	white-space: nowrap !important;
	padding-left: 16px !important;
	padding-right: 16px !important;
}

.highlight-target-plate {
	background-color: #fef3c7 !important;
	color: #92400e !important;
	font-weight: 900 !important;
	border: 1px solid #fde68a !important;
	border-radius: 8px;
	text-align: center !important;
	padding: 3px 8px !important;
	display: inline-block;
}

.premium-inner-input :deep(input) {
	text-align: center !important;
	font-weight: 700 !important;
	color: #1e293b !important;
}

/* ── Footer Stats ── */
.table-footer {
	padding: 12px 24px;
	border-top: 1px solid #e2e8f0;
}

.stat-box {
	display: flex;
	flex-direction: column;
	min-width: 100px;
	padding: 0 16px;
}

.stat-label {
	font-size: 10px;
	font-weight: 800;
	color: #94a3b8;
	text-transform: uppercase;
	letter-spacing: 0.1em;
}

.stat-value {
	font-size: 1.3rem;
	font-weight: 900;
	line-height: 1.2;
}

.stat-divider {
	width: 1px;
	height: 32px;
	background: #e2e8f0;
}

/* ── Otros ── */
.table-legend .legend-item {
	font-size: 10px;
	font-weight: 700;
	color: #64748b;
	margin-left: 16px;
	display: flex;
	align-items: center;
}

.dot {
	width: 8px;
	height: 8px;
	border-radius: 50%;
	margin-right: 6px;
}

.dot.success {
	background-color: #22c55e;
}

.dot.orange {
	background-color: #f97316;
}

.dot.purple {
	background-color: #a855f7;
}

.empty-state {
	text-align: center;
	padding: 80px 20px !important;
	background: white;
}

.empty-state h3 {
	font-weight: 900;
	color: #334155;
	margin-top: 16px;
}

.empty-state p {
	color: #64748b;
	max-width: 400px;
	margin: 8px auto 0;
}

.hover-grow {
	transition: transform 0.2s ease;
}

.hover-grow:hover {
	transform: scale(1.02);
}

.custom-scrollbar::-webkit-scrollbar {
	width: 6px;
	height: 6px;
}

.custom-scrollbar::-webkit-scrollbar-track {
	background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
	background: #cbd5e1;
	border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
	background: #94a3b8;
}

.w-100 {
	width: 100%;
}

.h-full {
	height: 100%;
}

.relative-pos {
	position: relative;
}

.opacity-50 {
	opacity: 0.5;
}

@media (max-width: 1264px) {
	.stat-box {
		min-width: 80px;
		padding: 0 10px;
	}

	.stat-value {
		font-size: 1.1rem;
	}
}

.v-menu__content {
	border-radius: 1.25rem !important;
}

.bg-glass {
	background: rgba(255, 255, 255, 0.95);
	backdrop-filter: blur(10px);
}

.bg-footer-modern {
	background: #f1f5f9;
	border-top: 1px solid #e2e8f0;
}

.letter-spacing-1 {
	letter-spacing: 1px;
}

.upload-zone-wrapper {
	width: 100%;
}

.upload-zone-label {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	padding: 8px 6px;
	border: 2px dashed #cbd5e1;
	border-radius: 20px;
	cursor: pointer;
	transition: all 0.3s ease;
	background: #f8fafc;
	text-align: center;
}

.upload-zone-label:hover {
	border-color: #2563eb;
	background: #eff6ff;
	transform: translateY(-2px);
}

.upload-zone-label.has-file {
	border-style: solid;
	border-color: #22c55e;
	background: #f0fdf4;
}

.truncate-text {
	max-width: 100%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.xml-zone {
	border-color: #4caf50 !important;
	background: #f1f8e9 !important;
}

.xml-zone:hover {
	border-color: #2e7d32 !important;
	background: #dcedc8 !important;
}

.pdf-zone {
	border-color: #b71c1c !important;
	background: #ffebee !important;
}

.pdf-zone:hover {
	border-color: #d32f2f !important;
	background: #ffcdd2 !important;
}

.upload-zone-label.has-file.xml-zone {
	border-style: solid;
	border-color: #2e7d32;
	background: #e8f5e9;
}

.upload-zone-label.has-file.pdf-zone {
	border-style: solid;
	border-color: #7f0000;
	background: #ffebee;
}

.modern-stat-card {
	display: flex;
	align-items: center;
	padding: 8px;
	border-radius: 16px;
	background: white;
	box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
	border: 1px solid #f1f5f9;
}

.modern-stat-card .card-icon {
	width: 44px;
	height: 44px;
	border-radius: 12px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-right: 16px;
}

.xml-total .card-icon {
	background: #f0fdf4;
}

.system-total .card-icon {
	background: #eef2ff;
}

.fruit-crates-total .card-icon {
	background: #fff7ed;
}

.materials-crates-total .card-icon {
	background: #eff6ff;
}

.modern-stat-card .card-content {
	display: flex;
	flex-direction: column;
}

.modern-stat-card .label {
	font-size: 10px;
	font-weight: 700;
	color: #64748b;
	text-transform: uppercase;
}

.modern-stat-card .value {
	font-size: 1.1rem;
	font-weight: 900;
}

.validation-banner {
	padding: 8px;
	border-radius: 16px;
	margin-top: 8px;
	border: 1px solid transparent;
}

.success-banner {
	background: #f0fdf4;
	border-color: #bbf7d0;
	color: #166534;
}

.error-banner {
	background: #fef2f2;
	border-color: #fecaca;
	color: #991b1b;
}

.banner-title {
	font-size: 1rem;
	line-height: 1.2;
}

.banner-desc {
	opacity: 0.8;
}

@media (max-width: 600px) {
	.upload-zone-label {
		padding: 30px 16px;
	}

	.modern-stat-card .value {
		font-size: 1rem;
	}
}

.column-typetransport {
	display: flex;
	align-items: center;
	gap: 8px;
}

.status-badge {
	display: flex;
	align-items: center;
	padding: 4px;
	border-radius: 50%;
	background-color: #e2f4ff;
	transition: all 0.2s ease;
}

.status-badge:hover {
	background-color: #bbdefb;
	transform: scale(1.1);
}

.status-icon {
	width: 14px;
	height: 14px;
}

*:focus {
	outline: none !important;
}

.v-btn:focus::before {
	opacity: 0 !important;
}

.elegant-toggle-wrap {
	display: inline-flex;
	align-items: center;
	cursor: pointer;
	user-select: none;
	gap: 6px;
	margin-top: 4px;
}

.elegant-toggle-input {
	display: none;
}

.elegant-toggle-slider {
	position: relative;
	width: 28px;
	height: 16px;
	background-color: #cbd5e1;
	border-radius: 99px;
	transition: background-color 0.2s ease, box-shadow 0.2s ease;
}

.elegant-toggle-slider::before {
	content: "";
	position: absolute;
	width: 12px;
	height: 12px;
	left: 2px;
	bottom: 2px;
	background-color: white;
	border-radius: 50%;
	transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.elegant-toggle-input:checked+.elegant-toggle-slider {
	background-color: #3b82f6;
}

.elegant-toggle-input:checked+.elegant-toggle-slider::before {
	transform: translateX(12px);
}

.elegant-toggle-text {
	font-size: 0.65rem !important;
	font-weight: 700;
	color: #64748b;
	text-transform: lowercase;
	transition: color 0.2s ease;
}

.elegant-toggle-input:checked~.elegant-toggle-text {
	color: #1e293b;
	font-weight: 800;
}
</style>
